const iconMapping = {
  'content-and-activities-activities-algebra-tiles': {
    file: 'content_and_activities/activities/algebra_tiles.svg',
    group: 'Content and Activities',
    name: 'Algebra Tiles',
    size: 'xl'
  },
  'content-and-activities-activities-algebra-tiles-red': {
    file: 'content_and_activities/activities/algebra_tiles_red.svg',
    group: 'Content and Activities',
    name: 'Algebra Tiles Red',
    size: 'xl'
  },
  'content-and-activities-activities-algebra-tiles-dark-blue': {
    file: 'content_and_activities/activities/algebra_tiles_dark_blue.svg',
    group: 'Content and Activities',
    name: 'Algebra Tiles Dark Blue',
    size: 'xl'
  },
  'content-and-activities-activities-alt-image-default': {
    file: 'content_and_activities/activities/alt_image_default.svg',
    group: 'Content and Activities',
    name: 'Alt Image Default',
    size: 'small'
  },
  'content-and-activities-activities-alt-image-hover': {
    file: 'content_and_activities/activities/alt_image_hover.svg',
    group: 'Content and Activities',
    name: 'Alt Image Hover',
    size: 'small'
  },
  'content-and-activities-activities-alt-image-white-default': {
    file: 'content_and_activities/activities/alt_image_white_default.svg',
    group: 'Content and Activities',
    name: 'Alt Image White Default',
    size: 'small'
  },
  'content-and-activities-activities-base-ten-blocks': {
    file: 'content_and_activities/activities/base_ten_blocks.svg',
    group: 'Content and Activities',
    name: 'Base Ten Blocks',
    size: 'xl'
  },
  'content-and-activities-activities-base-ten-blocks-red': {
    file: 'content_and_activities/activities/base_ten_blocks_red.svg',
    group: 'Content and Activities',
    name: 'Base Ten Blocks Red',
    size: 'xl'
  },
  'content-and-activities-activities-base-ten-blocks-dark-blue': {
    file: 'content_and_activities/activities/base_ten_blocks_dark_blue.svg',
    group: 'Content and Activities',
    name: 'Base Ten Blocks Dark Blue',
    size: 'xl'
  },
  'content-and-activities-activities-brain-breaks-yellow': {
    file: 'content_and_activities/activities/brain_breaks_yellow.svg',
    group: 'Content and Activities',
    name: 'Brain Breaks Yellow',
    size: 'xl'
  },
  'content-and-activities-activities-collaborate-board': {
    file: 'content_and_activities/activities/collaborate_board.svg',
    group: 'Content and Activities',
    name: 'Collaborate Board',
    size: 'xl'
  },
  'content-and-activities-activities-collaborate-board-purple': {
    file: 'content_and_activities/activities/collaborate_board_purple.svg',
    group: 'Content and Activities',
    name: 'Collaborate Board Purple',
    size: 'xl'
  },
  'content-and-activities-activities-color-tiles': {
    file: 'content_and_activities/activities/color_tiles.svg',
    group: 'Content and Activities',
    name: 'Color Tiles',
    size: 'xl'
  },
  'content-and-activities-activities-color-tiles-red': {
    file: 'content_and_activities/activities/color_tiles_red.svg',
    group: 'Content and Activities',
    name: 'Color Tiles Red',
    size: 'xl'
  },
  'content-and-activities-activities-color-tiles-dark-blue': {
    file: 'content_and_activities/activities/color_tiles_dark_blue.svg',
    group: 'Content and Activities',
    name: 'Color Tiles Dark Blue',
    size: 'xl'
  },
  'content-and-activities-activities-drag-and-drop': {
    file: 'content_and_activities/activities/drag_and_drop.svg',
    group: 'Content and Activities',
    name: 'Drag and Drop',
    size: 'xl'
  },
  'content-and-activities-activities-drag-and-drop-yellow': {
    file: 'content_and_activities/activities/drag_and_drop_yellow.svg',
    group: 'Content and Activities',
    name: 'Drag and Drop Yellow',
    size: 'xl'
  },
  'content-and-activities-activities-drawit': {
    file: 'content_and_activities/activities/drawit.svg',
    group: 'Content and Activities',
    name: 'Drawit',
    size: 'xl'
  },
  'content-and-activities-activities-drawit-yellow': {
    file: 'content_and_activities/activities/drawit_yellow.svg',
    group: 'Content and Activities',
    name: 'Drawit Yellow',
    size: 'xl'
  },
  'content-and-activities-activities-fill-in-the-blanks': {
    file: 'content_and_activities/activities/fill_in_the_blanks.svg',
    group: 'Content and Activities',
    name: 'Fill in the Blanks',
    size: 'xl'
  },
  'content-and-activities-activities-fill-in-the-blanks-yellow': {
    file: 'content_and_activities/activities/fill_in_the_blanks_yellow.svg',
    group: 'Content and Activities',
    name: 'Fill in the Blanks Yellow',
    size: 'xl'
  },
  'content-and-activities-activities-flipgrid': {
    file: 'content_and_activities/activities/flipgrid.svg',
    group: 'Content and Activities',
    name: 'Flipgrid',
    size: 'xl'
  },
  'content-and-activities-activities-flipgrid-purple': {
    file: 'content_and_activities/activities/flipgrid_purple.svg',
    group: 'Content and Activities',
    name: 'Flipgrid Purple',
    size: 'xl'
  },
  'content-and-activities-activities-fraction-tiles': {
    file: 'content_and_activities/activities/fraction_tiles.svg',
    group: 'Content and Activities',
    name: 'Fraction Tiles',
    size: 'xl'
  },
  'content-and-activities-activities-fraction-tiles-red': {
    file: 'content_and_activities/activities/fraction_tiles_red.svg',
    group: 'Content and Activities',
    name: 'Fraction Tiles Red',
    size: 'xl'
  },
  'content-and-activities-activities-fraction-tiles-dark-blue': {
    file: 'content_and_activities/activities/fraction_tiles_dark_blue.svg',
    group: 'Content and Activities',
    name: 'Fraction Tiles Dark Blue',
    size: 'xl'
  },
  'content-and-activities-activities-matching-pairs': {
    file: 'content_and_activities/activities/matching_pairs.svg',
    group: 'Content and Activities',
    name: 'Matching Pairs',
    size: 'xl'
  },
  'content-and-activities-activities-matching-pairs-yellow': {
    file: 'content_and_activities/activities/matching_pairs_yellow.svg',
    group: 'Content and Activities',
    name: 'Matching Pairs Yellow',
    size: 'xl'
  },
  'content-and-activities-activities-memory-game': {
    file: 'content_and_activities/activities/memory_game.svg',
    group: 'Content and Activities',
    name: 'Memory Game',
    size: 'xl'
  },
  'content-and-activities-activities-memory-game-yellow': {
    file: 'content_and_activities/activities/memory_game_yellow.svg',
    group: 'Content and Activities',
    name: 'Memory Game Yellow',
    size: 'xl'
  },
  'content-and-activities-activities-open-ended-questions': {
    file: 'content_and_activities/activities/open_ended_questions.svg',
    group: 'Content and Activities',
    name: 'Open-Ended Questions',
    size: 'xl'
  },
  'content-and-activities-activities-open-ended-questions-purple': {
    file: 'content_and_activities/activities/open_ended_questions_purple.svg',
    group: 'Content and Activities',
    name: 'Open-Ended Questions Purple',
    size: 'xl'
  },
  'content-and-activities-activities-polls': {
    file: 'content_and_activities/activities/polls.svg',
    group: 'Content and Activities',
    name: 'Polls',
    size: 'xl'
  },
  'content-and-activities-activities-polls-purple': {
    file: 'content_and_activities/activities/polls_purple.svg',
    group: 'Content and Activities',
    name: 'Polls Purple',
    size: 'xl'
  },
  'content-and-activities-activities-quiz': {
    file: 'content_and_activities/activities/quiz.svg',
    group: 'Content and Activities',
    name: 'Quiz',
    size: 'xl'
  },
  'content-and-activities-activities-quiz-yellow': {
    file: 'content_and_activities/activities/quiz_yellow.svg',
    group: 'Content and Activities',
    name: 'Quiz Yellow',
    size: 'xl'
  },
  'content-and-activities-activities-time-to-climb': {
    file: 'content_and_activities/activities/time_to_climb.svg',
    group: 'Content and Activities',
    name: 'Time to Climb',
    size: 'xl'
  },
  'content-and-activities-activities-time-to-climb-yellow': {
    file: 'content_and_activities/activities/time_to_climb_yellow.svg',
    group: 'Content and Activities',
    name: 'Time to Climb Yellow',
    size: 'xl'
  },
  'content-and-activities-background-bar-background': {
    file: 'content_and_activities/background_bar/background.svg',
    group: 'Content and Activities',
    name: 'Background',
    size: 'small'
  },
  'content-and-activities-background-bar-background-big': {
    file: 'content_and_activities/background_bar/background_big.svg',
    group: 'Content and Activities',
    name: 'Background Big',
    size: 'small'
  },
  'content-and-activities-background-bar-collapse': {
    file: 'content_and_activities/background_bar/collapse.svg',
    group: 'Content and Activities',
    name: 'Collapse',
    size: 'xs'
  },
  'content-and-activities-background-bar-color': {
    file: 'content_and_activities/background_bar/color.svg',
    group: 'Content and Activities',
    name: 'Color',
    size: 'small'
  },
  'content-and-activities-background-bar-color-big': {
    file: 'content_and_activities/background_bar/color_big.svg',
    group: 'Content and Activities',
    name: 'Color Big',
    size: 'small'
  },
  'content-and-activities-background-bar-delete': {
    file: 'content_and_activities/background_bar/delete.svg',
    group: 'Content and Activities',
    name: 'Delete',
    size: 'xs'
  },
  'content-and-activities-background-bar-flip-vertical': {
    file: 'content_and_activities/background_bar/flip_vertical.svg',
    group: 'Content and Activities',
    name: 'Flip Vertical',
    size: 'small'
  },
  'content-and-activities-background-bar-flip-horizontal': {
    file: 'content_and_activities/background_bar/flip_horizontal.svg',
    group: 'Content and Activities',
    name: 'Flip Horizontal',
    size: 'small'
  },
  'content-and-activities-background-bar-opacity': {
    file: 'content_and_activities/background_bar/opacity.svg',
    group: 'Content and Activities',
    name: 'Opacity',
    size: 'small'
  },
  'content-and-activities-background-bar-rotate-left': {
    file: 'content_and_activities/background_bar/rotate_left.svg',
    group: 'Content and Activities',
    name: 'Rotate Left',
    size: 'small'
  },
  'content-and-activities-background-bar-rotate-right': {
    file: 'content_and_activities/background_bar/rotate_right.svg',
    group: 'Content and Activities',
    name: 'Rotate Right',
    size: 'small'
  },
  'content-and-activities-background-bar-zoom': {
    file: 'content_and_activities/background_bar/zoom.svg',
    group: 'Content and Activities',
    name: 'Zoom',
    size: 'small'
  },
  'content-and-activities-collaborate-board-likes-dark-disabled': {
    file: 'content_and_activities/collaborate_board/likes_dark_disabled.svg',
    group: 'Content and Activities',
    name: 'Likes Dark Disabled',
    size: 'small'
  },
  'content-and-activities-collaborate-board-likes-dark-disabled-2': {
    file: 'content_and_activities/collaborate_board/likes_dark_disabled_2.svg',
    group: 'Content and Activities',
    name: 'Likes Dark Disabled 2',
    size: 'small'
  },
  'content-and-activities-collaborate-board-likes-dark-empty': {
    file: 'content_and_activities/collaborate_board/likes_dark_empty.svg',
    group: 'Content and Activities',
    name: 'Likes Dark Empty',
    size: 'small'
  },
  'content-and-activities-collaborate-board-likes-dark-empty-hover': {
    file: 'content_and_activities/collaborate_board/likes_dark_empty_hover.svg',
    group: 'Content and Activities',
    name: 'Likes Dark Empty Hover',
    size: 'small'
  },
  'content-and-activities-collaborate-board-likes-dark-filled': {
    file: 'content_and_activities/collaborate_board/likes_dark_filled.svg',
    group: 'Content and Activities',
    name: 'Likes Dark Filled',
    size: 'small'
  },
  'content-and-activities-collaborate-board-likes-dark-filled-hover': {
    file: 'content_and_activities/collaborate_board/likes_dark_filled_hover.svg',
    group: 'Content and Activities',
    name: 'Likes Dark Filled Hover',
    size: 'small'
  },
  'content-and-activities-collaborate-board-likes-red-filled': {
    file: 'content_and_activities/collaborate_board/likes_red_filled.svg',
    group: 'Content and Activities',
    name: 'Likes Red Filled',
    size: 'small'
  },
  'content-and-activities-collaborate-board-add-image-default': {
    file: 'content_and_activities/collaborate_board/add_image_default.svg',
    group: 'Content and Activities',
    name: 'Add Image Default',
    size: 'medium'
  },
  'content-and-activities-collaborate-board-add-image-disabled': {
    file: 'content_and_activities/collaborate_board/add_image_disabled.svg',
    group: 'Content and Activities',
    name: 'Add Image Disabled',
    size: 'medium'
  },
  'content-and-activities-collaborate-board-add-image-hover': {
    file: 'content_and_activities/collaborate_board/add_image_hover.svg',
    group: 'Content and Activities',
    name: 'Add Image Hover',
    size: 'medium'
  },
  'content-and-activities-collaborate-board-columns-dash': {
    file: 'content_and_activities/collaborate_board/columns_dash.svg',
    group: 'Content and Activities',
    name: 'Columns Dash',
    size: 'large'
  },
  'content-and-activities-collaborate-board-delete-default': {
    file: 'content_and_activities/collaborate_board/delete_default.svg',
    group: 'Content and Activities',
    name: 'Delete Default',
    size: 'medium'
  },
  'content-and-activities-collaborate-board-grid-dash': {
    file: 'content_and_activities/collaborate_board/grid_dash.svg',
    group: 'Content and Activities',
    name: 'Grid Dash',
    size: 'large'
  },
  'content-and-activities-collaborate-board-pending-post-default': {
    file: 'content_and_activities/collaborate_board/pending_post_default.svg',
    group: 'Content and Activities',
    name: 'Pending Post Default',
    size: 'large'
  },
  'content-and-activities-collaborate-board-pending-post-hover': {
    file: 'content_and_activities/collaborate_board/pending_post_hover.svg',
    group: 'Content and Activities',
    name: 'Pending Post Hover',
    size: 'large'
  },
  'content-and-activities-collaborate-board-restore-default': {
    file: 'content_and_activities/collaborate_board/restore_default.svg',
    group: 'Content and Activities',
    name: 'Restore Default',
    size: 'small'
  },
  'content-and-activities-collaborate-board-time-default': {
    file: 'content_and_activities/collaborate_board/time_default.svg',
    group: 'Content and Activities',
    name: 'Time Default',
    size: 'medium'
  },
  'content-and-activities-activities-formative-assessment-brown': {
    file: 'content_and_activities/activities/formative_assessment_brown.svg',
    group: 'Content and Activities',
    name: 'Formative Assessment brown',
    size: 'xl'
  },
  'content-and-activities-activities-formative-assessment-orange': {
    file: 'content_and_activities/activities/formative_assessment_orange.svg',
    group: 'Content and Activities',
    name: 'Formative Assessment orange',
    size: 'default'
  },
  'content-and-activities-formative-assessment-default': {
    file: 'content_and_activities/activities/formative_assessment_default.svg',
    group: 'Content and Activities',
    name: 'Formative Assessment Default',
    size: 'default'
  },
  'content-and-activities-formative-assessment-medium-white': {
    file: 'content_and_activities/activities/formative_assessment_white.svg',
    group: 'Content and Activities',
    name: 'Formative Assessment Medium White',
    size: 'medium'
  },
  'content-and-activities-formative-assessment-xs-white': {
    file: 'content_and_activities/activities/formative_assessment_white.svg',
    group: 'Content and Activities',
    name: 'Formative Assessment XS White',
    size: 'xs'
  },
  'content-and-activities-formative-assessment-quiz-done': {
    file: 'content_and_activities/activities/formative_assessment_quiz_done.svg',
    group: 'Content and Activities',
    name: 'Formative Assessment Quiz Done',
    size: 'default'
  },
  'content-and-activities-formative-assessment-round': {
    file: 'content_and_activities/activities/formative_assessment_round.svg',
    group: 'Content and Activities',
    name: 'Formative Assessment Round',
    size: 'xl'
  },
  'content-and-activities-content-3d': {
    file: 'content_and_activities/content/3d.svg',
    group: 'Reports',
    name: '3D',
    size: 'default'
  },
  'content-and-activities-content-3d-green': {
    file: 'content_and_activities/content/3d_green.svg',
    group: 'Reports',
    name: '3D Green',
    size: 'default'
  },
  'content-and-activities-content-audio-slide': {
    file: 'content_and_activities/content/audio_slide.svg',
    group: 'Reports',
    name: 'Audio Slide',
    size: 'default'
  },
  'content-and-activities-content-bbc': {
    file: 'content_and_activities/content/bbc.svg',
    group: 'Reports',
    name: 'BBC',
    size: 'default'
  },
  'content-and-activities-content-bbc-green': {
    file: 'content_and_activities/content/bbc_green.svg',
    group: 'Reports',
    name: 'BBC Green',
    size: 'default'
  },
  'content-and-activities-content-classic-slide-editor': {
    file: 'content_and_activities/content/classic_slide_editor.svg',
    group: 'Reports',
    name: 'Classic Slide Editor',
    size: 'default'
  },
  'content-and-activities-content-desmos': {
    file: 'content_and_activities/content/desmos.svg',
    group: 'Reports',
    name: 'Desmos',
    size: 'default'
  },
  'content-and-activities-content-pdf': {
    file: 'content_and_activities/content/pdf.svg',
    group: 'Reports',
    name: 'PDF',
    size: 'default'
  },
  'content-and-activities-content-phet': {
    file: 'content_and_activities/content/phet.svg',
    group: 'Reports',
    name: 'PhET',
    size: 'default'
  },
  'content-and-activities-content-phet-green': {
    file: 'content_and_activities/content/phet_green.svg',
    group: 'Reports',
    name: 'PhET Green',
    size: 'default'
  },
  'content-and-activities-content-slide-editor-beta': {
    file: 'content_and_activities/content/slide_editor_beta.svg',
    group: 'Reports',
    name: 'Slide Editor Beta',
    size: 'default'
  },
  'content-and-activities-content-slide-show': {
    file: 'content_and_activities/content/slide_show.svg',
    group: 'Reports',
    name: 'Slide Show',
    size: 'default'
  },
  'content-and-activities-content-sway': {
    file: 'content_and_activities/content/sway.svg',
    group: 'Reports',
    name: 'Sway',
    size: 'default'
  },
  'content-and-activities-content-variant2': {
    file: 'content_and_activities/content/variant2.svg',
    group: 'Reports',
    name: 'Variant2',
    size: 'default'
  },
  'content-and-activities-content-variant1': {
    file: 'content_and_activities/content/variant1.svg',
    group: 'Reports',
    name: 'Variant1',
    size: 'default'
  },
  'content-and-activities-content-video': {
    file: 'content_and_activities/content/video.svg',
    group: 'Reports',
    name: 'Video',
    size: 'default'
  },
  'content-and-activities-content-video-green': {
    file: 'content_and_activities/content/video_green.svg',
    group: 'Reports',
    name: 'Video Green',
    size: 'default'
  },
  'content-and-activities-content-vr': {
    file: 'content_and_activities/content/vr.svg',
    group: 'Reports',
    name: 'VR',
    size: 'default'
  },
  'content-and-activities-content-vr-green': {
    file: 'content_and_activities/content/vr_green.svg',
    group: 'Reports',
    name: 'VR Green',
    size: 'default'
  },
  'content-and-activities-content-web-content': {
    file: 'content_and_activities/content/web_content.svg',
    group: 'Reports',
    name: 'Web Content',
    size: 'default'
  },
  'content-and-activities-content-web-content-green': {
    file: 'content_and_activities/content/web_content_green.svg',
    group: 'Reports',
    name: 'Web Content Green',
    size: 'default'
  },
  'content-and-activities-content-brain-breaks-green': {
    file: 'content_and_activities/content/brain_breaks_green.svg',
    group: 'Reports',
    name: 'Brain Breaks Green',
    size: 'default'
  },
  'content-and-activities-drag-and-drop-128x128-blue': {
    file: 'content_and_activities/drag_and_drop/128x128_blue.svg',
    group: 'Content and Activities',
    name: '128x128 Blue',
    size: 'xxl'
  },
  'content-and-activities-fa-algebra-tiles': {
    file: 'content_and_activities/activities/algebra_tiles_red.svg',
    group: 'Content and Activities',
    name: 'Algebra Tiles',
    size: 'small'
  },
  'content-and-activities-fa-base-10-blocks': {
    file: 'content_and_activities/activities/base_ten_blocks_red.svg',
    group: 'Content and Activities',
    name: 'Base 10 Blocks',
    size: 'small'
  },
  'content-and-activities-fa-color-tiles': {
    file: 'content_and_activities/activities/color_tiles_red.svg',
    group: 'Content and Activities',
    name: 'Color Tiles',
    size: 'small'
  },
  'content-and-activities-fa-d&d': {
    file: 'content_and_activities/activities/drag_and_drop_yellow.svg',
    group: 'Content and Activities',
    name: 'Drag & Drop',
    size: 'small'
  },
  'content-and-activities-fa-draw-it': {
    file: 'content_and_activities/activities/drawit_yellow.svg',
    group: 'Content and Activities',
    name: 'Draw It',
    size: 'small'
  },
  'content-and-activities-fa-fitb': {
    file: 'content_and_activities/activities/fill_in_the_blanks_yellow.svg',
    group: 'Content and Activities',
    name: 'Fill In The Blanks',
    size: 'small'
  },
  'content-and-activities-fa-fraction-tiles': {
    file: 'content_and_activities/activities/fraction_tiles_red.svg',
    group: 'Content and Activities',
    name: 'Fraction Tiles',
    size: 'small'
  },
  'content-and-activities-fa-matching-pairs': {
    file: 'content_and_activities/activities/matching_pairs_yellow.svg',
    group: 'Content and Activities',
    name: 'Matching Pairs',
    size: 'small'
  },
  'content-and-activities-fa-quiz': {
    file: 'content_and_activities/activities/quiz_yellow.svg',
    group: 'Content and Activities',
    name: 'Quiz',
    size: 'small'
  },
  'content-and-activities-fa-oeq': {
    file: 'content_and_activities/activities/open_ended_questions_purple.svg',
    group: 'Content and Activities',
    name: 'Open-Ended Question',
    size: 'small'
  },
  'content-and-activities-fa-poll': {
    file: 'content_and_activities/activities/polls_purple.svg',
    group: 'Content and Activities',
    name: 'Poll',
    size: 'small'
  },
  'content-and-activities-fa-ttc': {
    file: 'content_and_activities/activities/time_to_climb_yellow.svg',
    group: 'Content and Activities',
    name: 'Time To Climb',
    size: 'small'
  },
  'content-and-activities-drag-and-drop-128x128-grey': {
    file: 'content_and_activities/drag_and_drop/128x128_grey.svg',
    group: 'Content and Activities',
    name: '128x128 Grey',
    size: 'xxl'
  },
  'content-and-activities-drag-and-drop-128x128-white': {
    file: 'content_and_activities/drag_and_drop/128x128_white.svg',
    group: 'Content and Activities',
    name: '128x128 White',
    size: 'xxl'
  },
  'content-and-activities-drag-and-drop-150x150-blue': {
    file: 'content_and_activities/drag_and_drop/150x150_blue.svg',
    group: 'Content and Activities',
    name: '150x150 Blue',
    size: 'xxxl'
  },
  'content-and-activities-drag-and-drop-150x150-grey': {
    file: 'content_and_activities/drag_and_drop/150x150_grey.svg',
    group: 'Content and Activities',
    name: '150x150 Grey',
    size: 'xxxl'
  },
  'content-and-activities-drag-and-drop-150x150-white': {
    file: 'content_and_activities/drag_and_drop/150x150_white.svg',
    group: 'Content and Activities',
    name: '150x150 White',
    size: 'xxxl'
  },
  'content-and-activities-drag-and-drop-24x24-blue': {
    file: 'content_and_activities/drag_and_drop/24x24_blue.svg',
    group: 'Content and Activities',
    name: '24x24 Blue',
    size: 'small'
  },
  'content-and-activities-drag-and-drop-24x24-white': {
    file: 'content_and_activities/drag_and_drop/24x24_white.svg',
    group: 'Content and Activities',
    name: '24x24 White',
    size: 'small'
  },
  'content-and-activities-drag-and-drop-48x48-blue': {
    file: 'content_and_activities/drag_and_drop/48x48_blue.svg',
    group: 'Content and Activities',
    name: '48x48 Blue',
    size: 'xl'
  },
  'content-and-activities-drawit-add-image-default': {
    file: 'content_and_activities/drawit/add_image_default.svg',
    group: 'Content and Activities',
    name: 'Add Image Default',
    size: 'large'
  },
  'content-and-activities-drawit-add-image-hover': {
    file: 'content_and_activities/drawit/add_image_hover.svg',
    group: 'Content and Activities',
    name: 'Add Image Hover',
    size: 'large'
  },
  'content-and-activities-drawit-crayon-default': {
    file: 'content_and_activities/drawit/crayon_default.svg',
    group: 'Content and Activities',
    name: 'Crayon Default',
    size: 'large'
  },
  'content-and-activities-drawit-crayon-hover': {
    file: 'content_and_activities/drawit/crayon_hover.svg',
    group: 'Content and Activities',
    name: 'Crayon Hover',
    size: 'large'
  },
  'content-and-activities-drawit-delete-medium-default': {
    file: 'content_and_activities/drawit/delete_default.svg',
    group: 'Content and Activities',
    name: 'Delete Medium Default',
    size: 'medium'
  },
  'content-and-activities-drawit-delete-medium-disabled': {
    file: 'content_and_activities/drawit/delete_disabled.svg',
    group: 'Content and Activities',
    name: 'Delete Medium Disabled',
    size: 'medium'
  },
  'content-and-activities-drawit-delete-default': {
    file: 'content_and_activities/drawit/delete_default.svg',
    group: 'Content and Activities',
    name: 'Delete Default',
    size: 'large'
  },
  'content-and-activities-drawit-delete-hover': {
    file: 'content_and_activities/drawit/delete_hover.svg',
    group: 'Content and Activities',
    name: 'Delete Hover',
    size: 'large'
  },
  'content-and-activities-drawit-erase-default': {
    file: 'content_and_activities/drawit/erase_default.svg',
    group: 'Content and Activities',
    name: 'Erase Default',
    size: 'large'
  },
  'content-and-activities-drawit-erase-hover': {
    file: 'content_and_activities/drawit/erase_hover.svg',
    group: 'Content and Activities',
    name: 'Erase Hover',
    size: 'large'
  },
  'content-and-activities-drawit-locked-small-default': {
    file: 'content_and_activities/drawit/locked_small_default.svg',
    group: 'Content and Activities',
    name: 'Locked Small Default',
    size: 'small'
  },
  'content-and-activities-drawit-locked-default': {
    file: 'content_and_activities/drawit/locked_default.svg',
    group: 'Content and Activities',
    name: 'Locked Default',
    size: 'large'
  },
  'content-and-activities-drawit-locked-hover': {
    file: 'content_and_activities/drawit/locked_hover.svg',
    group: 'Content and Activities',
    name: 'Locked Hover',
    size: 'large'
  },
  'content-and-activities-drawit-marker-default': {
    file: 'content_and_activities/drawit/marker_default.svg',
    group: 'Content and Activities',
    name: 'Marker Default',
    size: 'large'
  },
  'content-and-activities-drawit-marker-hover': {
    file: 'content_and_activities/drawit/marker_hover.svg',
    group: 'Content and Activities',
    name: 'Marker Hover',
    size: 'large'
  },
  'content-and-activities-drawit-redo-medium-default': {
    file: 'content_and_activities/drawit/redo_default.svg',
    group: 'Content and Activities',
    name: 'Redo Medium Default',
    size: 'medium'
  },
  'content-and-activities-drawit-convert-medium-default': {
    file: 'content_and_activities/drawit/convert_default.svg',
    group: 'Content and Activities',
    name: 'Convert Medium Default',
    size: 'medium'
  },
  'content-and-activities-drawit-redo-medium-disabled': {
    file: 'content_and_activities/drawit/redo_disabled.svg',
    group: 'Content and Activities',
    name: 'Redo Medium Disabled',
    size: 'medium'
  },
  'content-and-activities-drawit-redo-default': {
    file: 'content_and_activities/drawit/redo_default.svg',
    group: 'Content and Activities',
    name: 'Redo Default',
    size: 'large'
  },
  'content-and-activities-drawit-redo-disabled': {
    file: 'content_and_activities/drawit/redo_disabled.svg',
    group: 'Content and Activities',
    name: 'Redo Disabled',
    size: 'large'
  },
  'content-and-activities-drawit-redo-hover': {
    file: 'content_and_activities/drawit/redo_hover.svg',
    group: 'Content and Activities',
    name: 'Redo Hover',
    size: 'large'
  },
  'content-and-activities-drawit-select-default': {
    file: 'content_and_activities/drawit/select_default.svg',
    group: 'Content and Activities',
    name: 'Select Default',
    size: 'large'
  },
  'content-and-activities-drawit-select-hover': {
    file: 'content_and_activities/drawit/select_hover.svg',
    group: 'Content and Activities',
    name: 'Select Hover',
    size: 'large'
  },
  'content-and-activities-drawit-text-default': {
    file: 'content_and_activities/drawit/text_default.svg',
    group: 'Content and Activities',
    name: 'Text Default',
    size: 'medium'
  },
  'content-and-activities-drawit-text-hover': {
    file: 'content_and_activities/drawit/text_hover.svg',
    group: 'Content and Activities',
    name: 'Text Hover',
    size: 'large'
  },
  'content-and-activities-drawit-undo-default': {
    file: 'content_and_activities/drawit/undo_default.svg',
    group: 'Content and Activities',
    name: 'Undo Default',
    size: 'large'
  },
  'content-and-activities-drawit-undo-disabled': {
    file: 'content_and_activities/drawit/undo_disabled.svg',
    group: 'Content and Activities',
    name: 'Undo Disabled',
    size: 'large'
  },
  'content-and-activities-drawit-undo-hover': {
    file: 'content_and_activities/drawit/undo_hover.svg',
    group: 'Content and Activities',
    name: 'Undo Hover',
    size: 'large'
  },
  'content-and-activities-drawit-unlocked-default': {
    file: 'content_and_activities/drawit/unlocked_default.svg',
    group: 'Content and Activities',
    name: 'Unlocked Default',
    size: 'large'
  },
  'content-and-activities-drawit-unlocked-hover': {
    file: 'content_and_activities/drawit/unlocked_hover.svg',
    group: 'Content and Activities',
    name: 'Unlocked Hover',
    size: 'large'
  },
  'content-and-activities-manipulatives-delete': {
    file: 'content_and_activities/manipulatives/delete.svg',
    group: 'Content and Activities',
    name: 'Delete',
    size: 'large'
  },
  'content-and-activities-manipulatives-duplicate': {
    file: 'content_and_activities/manipulatives/duplicate.svg',
    group: 'Content and Activities',
    name: 'Duplicate',
    size: 'large'
  },
  'content-and-activities-manipulatives-edit': {
    file: 'content_and_activities/manipulatives/edit.svg',
    group: 'Content and Activities',
    name: 'Edit',
    size: 'large'
  },
  'content-and-activities-manipulatives-flip-horizontal': {
    file: 'content_and_activities/manipulatives/flip_horizontal.svg',
    group: 'Content and Activities',
    name: 'Flip Horizontal',
    size: 'large'
  },
  'content-and-activities-manipulatives-flip-vertical': {
    file: 'content_and_activities/manipulatives/flip_vertical.svg',
    group: 'Content and Activities',
    name: 'Flip Vertical',
    size: 'large'
  },
  'content-and-activities-manipulatives-link': {
    file: 'content_and_activities/manipulatives/link.svg',
    group: 'Content and Activities',
    name: 'Link',
    size: 'large'
  },
  'content-and-activities-manipulatives-merge': {
    file: 'content_and_activities/manipulatives/merge.svg',
    group: 'Content and Activities',
    name: 'Merge',
    size: 'large'
  },
  'content-and-activities-manipulatives-positive-negative': {
    file: 'content_and_activities/manipulatives/positive_negative.svg',
    group: 'Content and Activities',
    name: 'Positive Negative',
    size: 'large'
  },
  'content-and-activities-manipulatives-rotate': {
    file: 'content_and_activities/manipulatives/rotate.svg',
    group: 'Content and Activities',
    name: 'Rotate',
    size: 'large'
  },
  'content-and-activities-manipulatives-split': {
    file: 'content_and_activities/manipulatives/split.svg',
    group: 'Content and Activities',
    name: 'Split',
    size: 'large'
  },
  'content-and-activities-misc-check-default': {
    file: 'content_and_activities/misc/check_default.svg',
    group: 'Content and Activities',
    name: 'Check Default',
    size: 'large'
  },
  'content-and-activities-misc-check-hover': {
    file: 'content_and_activities/misc/check_hover.svg',
    group: 'Content and Activities',
    name: 'Check Hover',
    size: 'large'
  },
  'content-and-activities-misc-check-selected': {
    file: 'content_and_activities/misc/check_selected.svg',
    group: 'Content and Activities',
    name: 'Check Selected',
    size: 'large'
  },
  'content-and-activities-misc-delete': {
    file: 'content_and_activities/misc/delete.svg',
    group: 'Content and Activities',
    name: 'Delete',
    size: 'medium'
  },
  'content-and-activities-misc-delete-default': {
    file: 'content_and_activities/misc/delete_default.svg',
    group: 'Content and Activities',
    name: 'Delete Default',
    size: 'medium'
  },
  'content-and-activities-misc-delete-disabled': {
    file: 'content_and_activities/misc/delete_disabled.svg',
    group: 'Content and Activities',
    name: 'Delete Disabled',
    size: 'medium'
  },
  'content-and-activities-misc-drag-handler': {
    file: 'content_and_activities/misc/drag_handler.svg',
    group: 'Content and Activities',
    name: 'Drag Handler',
    size: 'small'
  },
  'content-and-activities-misc-duplicate-medium-black': {
    file: 'content_and_activities/misc/duplicate_black.svg',
    group: 'Content and Activities',
    name: 'Duplicate Medium Black',
    size: 'medium'
  },
  'content-and-activities-misc-duplicate-medium-black-disabled': {
    file: 'content_and_activities/misc/duplicate_disabled.svg',
    group: 'Content and Activities',
    name: 'Duplicate Medium Black Disabled',
    size: 'medium'
  },
  'content-and-activities-misc-duplicate-default': {
    file: 'content_and_activities/misc/duplicate_default.svg',
    group: 'Content and Activities',
    name: 'Duplicate Default',
    size: 'small'
  },
  'content-and-activities-misc-duplicate-hover': {
    file: 'content_and_activities/misc/duplicate_hover.svg',
    group: 'Content and Activities',
    name: 'Duplicate Hover',
    size: 'small'
  },
  'content-and-activities-misc-math-function-default': {
    file: 'content_and_activities/misc/math_function_default.svg',
    group: 'Content and Activities',
    name: 'Math Function Default',
    size: 'large'
  },
  'content-and-activities-misc-math-function-disabled': {
    file: 'content_and_activities/misc/math_function_disabled.svg',
    group: 'Content and Activities',
    name: 'Math Function Disabled',
    size: 'large'
  },
  'content-and-activities-misc-math-function-hover': {
    file: 'content_and_activities/misc/math_function_hover.svg',
    group: 'Content and Activities',
    name: 'Math Function Hover',
    size: 'large'
  },
  'content-and-activities-misc-text-default': {
    file: 'content_and_activities/misc/text_default.svg',
    group: 'Content and Activities',
    name: 'Text Default',
    size: 'small'
  },
  'content-and-activities-misc-text-selected': {
    file: 'content_and_activities/misc/text_selected.svg',
    group: 'Content and Activities',
    name: 'Text Selected',
    size: 'small'
  },
  'content-and-activities-misc-text-style': {
    file: 'content_and_activities/misc/text_style.svg',
    group: 'Content and Activities',
    name: 'Text Style',
    size: 'xs'
  },
  'content-and-activities-misc-timer-blue': {
    file: 'content_and_activities/misc/timer_blue_xs.svg',
    group: 'Content and Activities',
    name: 'Timer Blue',
    size: 'small'
  },
  'content-and-activities-misc-timer-grey': {
    file: 'content_and_activities/misc/timer_grey.svg',
    group: 'Content and Activities',
    name: 'Timer Grey',
    size: 'xl'
  },
  'content-and-activities-misc-timer-white': {
    file: 'content_and_activities/misc/timer_white.svg',
    group: 'Content and Activities',
    name: 'Timer White',
    size: 'xl'
  },
  'content-and-activities-misc-timer-restart-xss': {
    file: 'content_and_activities/misc/timer_restart_xss.svg',
    group: 'Content and Activities',
    name: 'Timer Restart',
    size: 'xss'
  },
  'content-and-activities-nearpod-math-aligned-resources-content-package': {
    file: 'content_and_activities/nearpod_math/aligned_resources_content_package.svg',
    group: 'Content and Activities',
    name: 'Aligned Resources Content Package',
    size: 'xl'
  },
  'content-and-activities-nearpod-math-lessons': {
    file: 'content_and_activities/nearpod_math/lessons.svg',
    group: 'Content and Activities',
    name: 'Lessons',
    size: 'xl'
  },
  'content-and-activities-nearpod-math-minutes-dark': {
    file: 'content_and_activities/nearpod_math/minutes_dark.svg',
    group: 'Content and Activities',
    name: 'Minutes Dark',
    size: 'xl'
  },
  'content-and-activities-nearpod-math-minutes-white': {
    file: 'content_and_activities/nearpod_math/minutes_white.svg',
    group: 'Content and Activities',
    name: 'Minutes White',
    size: 'xl'
  },
  'content-and-activities-nearpod-math-slides-dark': {
    file: 'content_and_activities/nearpod_math/slides_dark.svg',
    group: 'Content and Activities',
    name: 'Slides Dark',
    size: 'xl'
  },
  'content-and-activities-nearpod-math-slides-white': {
    file: 'content_and_activities/nearpod_math/slides_white.svg',
    group: 'Content and Activities',
    name: 'Slides White',
    size: 'xl'
  },
  'content-and-activities-nearpod-math-teach': {
    file: 'content_and_activities/nearpod_math/teach.svg',
    group: 'Content and Activities',
    name: 'Teach',
    size: 'xl'
  },
  'content-and-activities-nearpod-math-units': {
    file: 'content_and_activities/nearpod_math/units.svg',
    group: 'Content and Activities',
    name: 'Units',
    size: 'xl'
  },
  'content-and-activities-nearpod-math-weeks': {
    file: 'content_and_activities/nearpod_math/weeks.svg',
    group: 'Content and Activities',
    name: 'Weeks',
    size: 'xl'
  },
  'content-and-activities-content-images': {
    file: 'content_and_activities/content/images.svg',
    group: 'Content and Activities',
    name: 'Images',
    size: 'default'
  },
  'content-and-activities-content-powerpoint': {
    file: 'content_and_activities/content/powerpoint.svg',
    group: 'Content and Activities',
    name: 'Powerpoint',
    size: 'default'
  },
  'content-and-activities-content-presentations': {
    file: 'content_and_activities/content/presentations.svg',
    group: 'Content and Activities',
    name: 'Presentations',
    size: 'default'
  },
  'content-and-activities-reference-media-add-image': {
    file: 'content_and_activities/reference_media/add_image.svg',
    group: 'Content and Activities',
    name: 'Add Image',
    size: 'small'
  },
  'content-and-activities-reference-media-audio-file': {
    file: 'content_and_activities/reference_media/audio_file.svg',
    group: 'Content and Activities',
    name: 'Audio File',
    size: 'small'
  },
  'content-and-activities-reference-media-pdf': {
    file: 'content_and_activities/reference_media/pdf.svg',
    group: 'Content and Activities',
    name: 'PDF',
    size: 'small'
  },
  'content-and-activities-reference-media-record': {
    file: 'content_and_activities/reference_media/record.svg',
    group: 'Content and Activities',
    name: 'Record',
    size: 'small'
  },
  'content-and-activities-reference-media-reference-media': {
    file: 'content_and_activities/reference_media/reference_media.svg',
    group: 'Content and Activities',
    name: 'Reference Media',
    size: 'xl'
  },
  'content-and-activities-reference-media-video': {
    file: 'content_and_activities/reference_media/video.svg',
    group: 'Content and Activities',
    name: 'Video',
    size: 'small'
  },
  'content-and-activities-reference-media-web-content': {
    file: 'content_and_activities/reference_media/web_content.svg',
    group: 'Content and Activities',
    name: 'Web Content',
    size: 'small'
  },
  'content-and-activities-video-audio-controls-default-blue-default': {
    file: 'content_and_activities/video_audio_controls/default_blue_default.svg',
    group: 'Content and Activities',
    name: 'Default Blue Default',
    size: 'small'
  },
  'content-and-activities-video-audio-controls-mute-white-default': {
    file: 'content_and_activities/video_audio_controls/mute_white_default.svg',
    group: 'Content and Activities',
    name: 'Mute White Default',
    size: 'small'
  },
  'content-and-activities-video-audio-controls-pause-blue-default': {
    file: 'content_and_activities/video_audio_controls/pause_blue_default.svg',
    group: 'Content and Activities',
    name: 'Pause Blue Default',
    size: 'small'
  },
  'content-and-activities-video-audio-controls-pause-gray-small': {
    file: 'content_and_activities/video_audio_controls/pause_gray_small.svg',
    group: 'Content and Activities',
    name: 'Pause Gray Small',
    size: 'xs'
  },
  'content-and-activities-video-audio-controls-pause-white-default': {
    file: 'content_and_activities/video_audio_controls/pause_white_default.svg',
    group: 'Content and Activities',
    name: 'Pause White Default',
    size: 'small'
  },
  'content-and-activities-video-audio-controls-play-blue-default': {
    file: 'content_and_activities/video_audio_controls/play_blue_default.svg',
    group: 'Content and Activities',
    name: 'Play Blue Default',
    size: 'small'
  },
  'content-and-activities-video-audio-controls-play-white-default': {
    file: 'content_and_activities/video_audio_controls/play_white_default.svg',
    group: 'Content and Activities',
    name: 'Play White Default',
    size: 'small'
  },
  'content-and-activities-video-audio-controls-randomize-gray-small': {
    file: 'content_and_activities/video_audio_controls/randomize_gray_small.svg',
    group: 'Content and Activities',
    name: 'Randomize Gray Small',
    size: 'xs'
  },
  'content-and-activities-video-audio-controls-setting-white-default': {
    file: 'content_and_activities/video_audio_controls/setting_white_default.svg',
    group: 'Content and Activities',
    name: 'Setting White Default',
    size: 'small'
  },
  'content-and-activities-video-audio-controls-stop-red-default': {
    file: 'content_and_activities/video_audio_controls/stop_red_default.svg',
    group: 'Content and Activities',
    name: 'Stop Red Default',
    size: 'small'
  },
  'content-and-activities-video-audio-controls-stop-white-default': {
    file: 'content_and_activities/video_audio_controls/stop_white_default.svg',
    group: 'Content and Activities',
    name: 'Stop White Default',
    size: 'small'
  },
  'content-and-activities-video-audio-controls-timer-white-default': {
    file: 'content_and_activities/video_audio_controls/timer_white_default.svg',
    group: 'Content and Activities',
    name: 'Timer White Default',
    size: 'small'
  },
  'content-and-activities-video-audio-controls-volume-gray-small': {
    file: 'content_and_activities/video_audio_controls/volume_gray_small.svg',
    group: 'Content and Activities',
    name: 'Volume Gray Small',
    size: 'xs'
  },
  'content-and-activities-video-audio-controls-volume-white-default': {
    file: 'content_and_activities/video_audio_controls/volume_white_default.svg',
    group: 'Content and Activities',
    name: 'Volume White Default',
    size: 'small'
  },
  'content-and-activities-grading-approve-default': {
    file: 'content_and_activities/grading/approve_default.svg',
    group: 'Content and Activities',
    name: 'Approve',
    size: 'small'
  },
  'content-and-activities-grading-approve-xs': {
    file: 'content_and_activities/grading/approve_default.svg',
    group: 'Content and Activities',
    name: 'Approve',
    size: 'xs'
  },
  'content-and-activities-grading-disapprove-default': {
    file: 'content_and_activities/grading/disapprove_default.svg',
    group: 'Content and Activities',
    name: 'Disapprove',
    size: 'small'
  },
  'content-and-activities-grading-disapprove-xs': {
    file: 'content_and_activities/grading/disapprove_default.svg',
    group: 'Content and Activities',
    name: 'Disapprove',
    size: 'xs'
  },
  'content-and-activities-grading-question-default': {
    file: 'content_and_activities/grading/question_default.svg',
    group: 'Content and Activities',
    name: 'Question',
    size: 'small'
  },
  'content-and-activities-grading-question-xs': {
    file: 'content_and_activities/grading/question_default.svg',
    group: 'Content and Activities',
    name: 'Question',
    size: 'xs'
  },
  'content-and-activities-grading-participated-default': {
    file: 'content_and_activities/grading/participated.svg',
    group: 'Content and Activities',
    name: 'Participated',
    size: 'small'
  },
  'content-and-activities-grading-participated-xs': {
    file: 'content_and_activities/grading/participated.svg',
    group: 'Content and Activities',
    name: 'Participated',
    size: 'xs'
  },
  'content-and-activities-grading-not-participated-default': {
    file: 'content_and_activities/grading/not_participated.svg',
    group: 'Content and Activities',
    name: 'Not Participated',
    size: 'small'
  },
  'content-and-activities-grading-not-participated-xs': {
    file: 'content_and_activities/grading/not_participated.svg',
    group: 'Content and Activities',
    name: 'Not Participated',
    size: 'xs'
  },
  'content-and-activities-grading-unset-default': {
    file: 'content_and_activities/grading/unset_default.svg',
    group: 'Content and Activities',
    name: 'No grade',
    size: 'small'
  },
  'content-and-activities-grading-grade-default': {
    file: 'content_and_activities/grading/grade_default.svg',
    group: 'Content and Activities',
    name: 'Grade',
    size: 'small'
  },
  'content-and-activities-grading-grade-default-disabled': {
    file: 'content_and_activities/grading/grade_default_disabled.svg',
    group: 'Content and Activities',
    name: 'Grade disabled',
    size: 'small'
  },
  'content-creation-saving-state-saved': {
    file: 'content_creation/saved.svg',
    group: 'Content Creation',
    name: 'Saved',
    size: 'small'
  },
  'content-creation-saving-state-saving': {
    file: 'content_creation/saving.svg',
    group: 'Content Creation',
    name: 'Saving',
    size: 'small'
  },
  'content-creation-saving-state-not-saved': {
    file: 'content_creation/not-saved.svg',
    group: 'Content Creation',
    name: 'Not saved',
    size: 'small'
  },
  'content-creation-saving-state-no-connection': {
    file: 'content_creation/no-connection.svg',
    group: 'Content Creation',
    name: 'No connection',
    size: 'small'
  },
  'content-creation-add-quick-slide-small-default': {
    file: 'content_creation/add-quick-slide-small-default.svg',
    group: 'Content Creation',
    name: 'Add quick slide default',
    size: 'small'
  },
  'content-creation-add-quick-slide-small-disabled': {
    file: 'content_creation/add-quick-slide-small-disabled.svg',
    group: 'Content Creation',
    name: 'Add quick slide disabled',
    size: 'small'
  },
  'content-creation-add-quiz-small-default': {
    file: 'content_creation/add-quiz-small-default.svg',
    group: 'Content Creation',
    name: 'Add quiz default',
    size: 'small'
  },
  'content-creation-add-quiz-small-disabled': {
    file: 'content_creation/add-quiz-small-disabled.svg',
    group: 'Content Creation',
    name: 'Add quiz disabled',
    size: 'small'
  },
  'content-creation-file-upload-small-default': {
    file: 'content_creation/file-upload-small-default.svg',
    group: 'Content Creation',
    name: 'Upload file default',
    size: 'small'
  },
  'content-creation-file-upload-small-disabled': {
    file: 'content_creation/file-upload-small-disabled.svg',
    group: 'Content Creation',
    name: 'Upload file disabled',
    size: 'small'
  },
  'content-creation-expand-more-small-default': {
    file: 'content_creation/expand-more-small-default.svg',
    group: 'Content Creation',
    name: 'Expand more default',
    size: 'small'
  },
  'floating-toolbar-add-to-my-lessons-xs': {
    file: 'floating_toolbar/add_to_my_lessons.svg',
    group: 'Floating Toolbar',
    name: 'Add to my lessons',
    size: 'xs'
  },
  'floating-toolbar-copy-xs': {
    file: 'floating_toolbar/copy.svg',
    group: 'Floating Toolbar',
    name: 'Copy',
    size: 'xs'
  },
  'floating-toolbar-delete-xs': {
    file: 'floating_toolbar/delete.svg',
    group: 'Floating Toolbar',
    name: 'Delete',
    size: 'xs'
  },
  'floating-toolbar-folder-xs': {
    file: 'floating_toolbar/folder.svg',
    group: 'Floating Toolbar',
    name: 'Folder',
    size: 'xs'
  },
  'floating-toolbar-folder-red-xs': {
    file: 'floating_toolbar/folder_red.svg',
    group: 'Floating Toolbar Red',
    name: 'Folder Red',
    size: 'xs'
  },
  'floating-toolbar-move-xs': {
    file: 'floating_toolbar/move.svg',
    group: 'Floating Toolbar',
    name: 'Move',
    size: 'xs'
  },
  'file-picker-drive': {
    file: 'file_picker/drive.svg',
    group: 'File Picker',
    name: 'Drive',
    size: 'large'
  },
  'file-picker-dropbox': {
    file: 'file_picker/dropbox.svg',
    group: 'File Picker',
    name: 'Dropbox',
    size: 'large'
  },
  'file-picker-dropbox-new': {
    file: 'file_picker/dropbox_new.svg',
    group: 'File Picker',
    name: 'Dropbox New',
    size: 'default'
  },
  'file-picker-one-drive': {
    file: 'file_picker/one_drive.svg',
    group: 'File Picker',
    name: 'One Drive',
    size: 'large'
  },
  'file-picker-one-drive-new': {
    file: 'file_picker/onedrive_new.svg',
    group: 'File Picker',
    name: 'One Drive New',
    size: 'default'
  },
  'file-picker-drop-audio': {
    file: 'file_picker/drop_audio.svg',
    group: 'File Picker',
    name: 'Drop Audio',
    size: 'xxxl'
  },
  'file-picker-drop-img': {
    file: 'file_picker/drop_img.svg',
    group: 'File Picker',
    name: 'Drop Image',
    size: 'xxxl'
  },
  'file-picker-drop-pdf': {
    file: 'file_picker/drop_pdf.svg',
    group: 'File Picker',
    name: 'Drop Pdf',
    size: 'xxxl'
  },
  'file-picker-drop-video': {
    file: 'file_picker/drop_video.svg',
    group: 'File Picker',
    name: 'Drop Video',
    size: 'xxxl'
  },
  'graph-tooltip-dash': {
    file: 'graph_tooltip/dash.svg',
    group: 'Graph Tooltip',
    name: 'Dash',
    size: 'xs'
  },
  'graph-tooltip-play-circle': {
    file: 'graph_tooltip/play_circle.svg',
    group: 'Graph Tooltip',
    name: 'Play Circle',
    size: 'xs'
  },
  'graph-tooltip-student-paced': {
    file: 'graph_tooltip/student_paced.svg',
    group: 'Graph Tooltip',
    name: 'Student Paced',
    size: 'xs'
  },
  'content-creation-add-element': {
    file: 'content_creation/add-element.svg',
    group: 'Content Creation',
    name: 'Add element',
    size: 'small'
  },
  'in-session-active-sessions-default': {
    file: 'in_session/active_sessions_default.svg',
    group: 'In Session',
    name: 'Active Sessions Default',
    size: 'small'
  },
  'in-session-active-sessions-disabled': {
    file: 'in_session/active_sessions_disabled.svg',
    group: 'In Session',
    name: 'Active Sessions Disabled',
    size: 'small'
  },
  'in-session-active-sessions-hover': {
    file: 'in_session/active_sessions_hover.svg',
    group: 'In Session',
    name: 'Active Sessions Hover',
    size: 'small'
  },
  'in-session-add-a-slide': {
    file: 'in_session/add_a_slide.svg',
    group: 'In Session',
    name: 'Add a Slide',
    size: 'small'
  },
  'in-session-annotations': {
    file: 'in_session/annotations.svg',
    group: 'In Session',
    name: 'Annotations',
    size: 'small'
  },
  'in-session-brain-breaks-blue-big': {
    file: 'in_session/brain_breaks_blue_big.svg',
    group: 'In Session',
    name: 'Brain Breaks Blue Big',
    size: 'xl'
  },
  'in-session-brain-breaks-dark': {
    file: 'in_session/brain_breaks_dark.svg',
    group: 'In Session',
    name: 'Brain Breaks Dark',
    size: 'small'
  },
  'in-session-brain-breaks-dark-grey': {
    file: 'in_session/brain_breaks_dark_grey.svg',
    group: 'In Session',
    name: 'Brain Breaks Dark Grey',
    size: 'small'
  },
  'in-session-credits': {
    file: 'in_session/credits.svg',
    group: 'In Session',
    name: 'Credits',
    size: 'small'
  },
  'in-session-collapse-expand-bottom-bar-collapse': {
    file: 'in_session/collapse_expand_bottom_bar_collapse.svg',
    group: 'In Session',
    name: 'Collapse Expand Bottom Bar Collapse',
    size: 'large'
  },
  'in-session-collapse-expand-bottom-bar-expand': {
    file: 'in_session/collapse_expand_bottom_bar_expand.svg',
    group: 'In Session',
    name: 'Collapse Expand Bottom Bar Expand',
    size: 'large'
  },
  'in-session-end-session': {
    file: 'in_session/end_session.svg',
    group: 'In Session',
    name: 'End Session',
    size: 'small'
  },
  'in-session-end-session-red': {
    file: 'in_session/end_session_red.svg',
    group: 'In Session',
    name: 'End Session Red',
    size: 'small'
  },
  'in-session-exit': {
    file: 'in_session/exit.svg',
    group: 'In Session',
    name: 'Exit',
    size: 'large'
  },
  'in-session-exit-arrow': {
    file: 'in_session/exit_arrow.svg',
    group: 'In Session',
    name: 'Exit Arrow',
    size: 'large'
  },
  'in-session-expand-to-full-screen-default': {
    file: 'in_session/expand_to_full_screen_default.svg',
    group: 'In Session',
    name: 'Expand to Full Screen Default',
    size: 'small'
  },
  'in-session-expand-to-full-screen-hover': {
    file: 'in_session/expand_to_full_screen_hover.svg',
    group: 'In Session',
    name: 'Expand to Full Screen Hover',
    size: 'small'
  },
  'in-session-front-of-the-class': {
    file: 'in_session/front_of_the_class.svg',
    group: 'In Session',
    name: 'Front of the Class',
    size: 'small'
  },
  'in-session-whiteboard-large': {
    file: 'in_session/whiteboard_large.svg',
    group: 'In Session',
    name: 'Whiteboard Large',
    size: 'medium'
  },
  'in-session-whiteboard-medium': {
    file: 'in_session/whiteboard_medium.svg',
    group: 'In Session',
    name: 'Whiteboard Medium',
    size: 'small'
  },
  'in-session-whiteboard-small': {
    file: 'in_session/whiteboard_small.svg',
    group: 'In Session',
    name: 'Whiteboard Small',
    size: 'xs'
  },
  'in-session-linkout-big': {
    file: 'in_session/linkout_big.svg',
    group: 'In Session',
    name: 'Linkout Big',
    size: 'medium'
  },
  'in-session-linkout-big-grey': {
    file: 'in_session/linkout_big_grey.svg',
    group: 'In Session',
    name: 'Linkout Big Grey',
    size: 'medium'
  },
  'in-session-linkout-small': {
    file: 'in_session/linkout_small.svg',
    group: 'In Session',
    name: 'Linkout Small',
    size: 'xs'
  },
  'in-session-live-lesson-default-blue': {
    file: 'in_session/live_lesson_default_blue.svg',
    group: 'In Session',
    name: 'Live Lesson Default Blue',
    size: 'medium'
  },
  'in-session-live-lesson-default-blue-small': {
    file: 'in_session/live_lesson_default_blue.svg',
    group: 'In Session',
    name: 'Live Lesson Default Blue Small',
    size: 'small'
  },
  'in-session-live-lesson-default-white': {
    file: 'in_session/live_lesson_default_white.svg',
    group: 'In Session',
    name: 'Live Lesson Default White',
    size: 'medium'
  },
  'in-session-live-lesson-disabled-white': {
    file: 'in_session/live_lesson_disabled_white.svg',
    group: 'In Session',
    name: 'Live Lesson Disabled White',
    size: 'medium'
  },
  'in-session-live-lesson-hover-white': {
    file: 'in_session/live_lesson_hover_white.svg',
    group: 'In Session',
    name: 'Live Lesson Hover White',
    size: 'medium'
  },
  'in-session-modal-code': {
    file: 'in_session/modal/code.svg',
    group: 'In Session',
    name: 'Modal Code',
    size: 'large'
  },
  'in-session-modal-datepicker': {
    file: 'in_session/modal/datepicker.svg',
    group: 'In Session',
    name: 'Modal Datepicker',
    size: 'large'
  },
  'in-session-modal-email': {
    file: 'in_session/modal/email.svg',
    group: 'In Session',
    name: 'Modal Email',
    size: 'large'
  },
  'in-session-modal-link': {
    file: 'in_session/modal/link.svg',
    group: 'In Session',
    name: 'Modal Link',
    size: 'large'
  },
  'in-session-modal-link-xs': {
    file: 'in_session/modal/link.svg',
    group: 'In Session',
    name: 'Modal Link',
    size: 'xs'
  },
  'in-session-notes-in-session-grey': {
    file: 'in_session/notes_in_session_grey.svg',
    group: 'In Session',
    name: 'Notes in Session Grey',
    size: 'small'
  },
  'in-session-notes-in-session-white': {
    file: 'in_session/notes_in_session_white.svg',
    group: 'In Session',
    name: 'Notes in Session White',
    size: 'medium'
  },
  'in-session-open-in-separate-window': {
    file: 'in_session/open_in_separate_window.svg',
    group: 'In Session',
    name: 'Open in Separate Window',
    size: 'small'
  },
  'in-session-rejoin-lesson-default': {
    file: 'in_session/rejoin_lesson_default.svg',
    group: 'In Session',
    name: 'Rejoin Lesson Default',
    size: 'small'
  },
  'in-session-rejoin-lesson-variant2': {
    file: 'in_session/rejoin_lesson_variant2.svg',
    group: 'In Session',
    name: 'Rejoin Lesson Variant2',
    size: 'small'
  },
  'in-session-rejoin-lesson-variant3': {
    file: 'in_session/rejoin_lesson_variant3.svg',
    group: 'In Session',
    name: 'Rejoin Lesson Variant3',
    size: 'small'
  },
  'in-session-share-code-big': {
    file: 'in_session/share_code_big.svg',
    group: 'In Session',
    name: 'Share Code Big',
    size: 'medium'
  },
  'in-session-share-code-small': {
    file: 'in_session/share_code_small.svg',
    group: 'In Session',
    name: 'Share Code Small',
    size: 'xs'
  },
  'in-session-showexpandcode-collapse': {
    file: 'in_session/showexpandcode_collapse.svg',
    group: 'In Session',
    name: 'Show / Expand Code Collapse',
    size: 'large'
  },
  'in-session-showexpandcode-expand': {
    file: 'in_session/showexpandcode_expand.svg',
    group: 'In Session',
    name: 'Show / Expand Code Expand',
    size: 'large'
  },
  'in-session-student-paced-default-dark': {
    file: 'in_session/student_paced_default_dark.svg',
    group: 'In Session',
    name: 'Student Paced Default Dark',
    size: 'small'
  },
  'in-session-student-paced-default-white': {
    file: 'in_session/student_paced_default_white.svg',
    group: 'In Session',
    name: 'Student Paced Default White',
    size: 'small'
  },
  'in-session-student-paced-default-yellow': {
    file: 'in_session/student_paced_default_yellow.svg',
    group: 'In Session',
    name: 'Student Paced Default Yellow',
    size: 'small'
  },
  'in-session-student-paced-disabled-dark': {
    file: 'in_session/student_paced_disabled_dark.svg',
    group: 'In Session',
    name: 'Student Paced Disabled Dark',
    size: 'small'
  },
  'in-session-student-paced-hover-dark': {
    file: 'in_session/student_paced_hover_dark.svg',
    group: 'In Session',
    name: 'Student Paced Hover Dark',
    size: 'small'
  },
  'in-session-student-view-blue': {
    file: 'in_session/student_view_blue.svg',
    group: 'In Session',
    name: 'Student View Blue',
    size: 'large'
  },
  'in-session-student-view-white': {
    file: 'in_session/student_view_white.svg',
    group: 'In Session',
    name: 'Student View White',
    size: 'large'
  },
  'in-session-students-dark': {
    file: 'in_session/students_dark.svg',
    group: 'In Session',
    name: 'Students Dark',
    size: 'medium'
  },
  'in-session-students-white': {
    file: 'in_session/students_white.svg',
    group: 'In Session',
    name: 'Students White',
    size: 'medium'
  },
  'in-session-teach': {
    file: 'in_session/teach.svg',
    group: 'In Session',
    name: 'Teach',
    size: 'small'
  },
  'in-session-teacher-view-blue': {
    file: 'in_session/teacher_view_blue.svg',
    group: 'In Session',
    name: 'Teacher View Blue',
    size: 'large'
  },
  'in-session-teacher-view-white': {
    file: 'in_session/teacher_view_white.svg',
    group: 'In Session',
    name: 'Teacher View White',
    size: 'large'
  },
  'in-session-top-bar-up-down-collapse': {
    file: 'in_session/top_bar_up_down_collapse.svg',
    group: 'In Session',
    name: 'Top Bar Up Down Collapse',
    size: 'large'
  },
  'in-session-top-bar-up-down-expand': {
    file: 'in_session/top_bar_up_down_expand.svg',
    group: 'In Session',
    name: 'Top Bar Up Down Expand',
    size: 'large'
  },
  'in-session-true-or-false': {
    file: 'in_session/true_or_false.svg',
    group: 'In Session',
    name: 'True or False',
    size: 'medium'
  },
  'in-session-teach-live-small': {
    file: 'in_session/teach_live.svg',
    group: 'In Session',
    name: 'Teach Live',
    size: 'small'
  },
  'in-session-teach-live-xs': {
    file: 'in_session/teach_live.svg',
    group: 'In Session',
    name: 'Teach Live',
    size: 'xs'
  },
  'in-session-teach-co-present-small': {
    file: 'in_session/teach_co_present.svg',
    group: 'In Session',
    name: 'Teach Co Present',
    size: 'small'
  },
  'in-session-teach-front-of-class-small': {
    file: 'in_session/teach_front_of_class.svg',
    group: 'In Session',
    name: 'Teach front of class',
    size: 'small'
  },
  'left-navigation-add-default': {
    file: 'left_navigation/add_default.svg',
    group: 'Left Navigation',
    name: 'Add Default',
    size: 'xs'
  },
  'left-navigation-folder-default': {
    file: 'left_navigation/folder_default.svg',
    group: 'Left Navigation',
    name: 'Folder Default',
    size: 'xs'
  },
  'main-navbar-activities-blue': {
    file: 'main_navbar/activities_blue.svg',
    group: 'Main Navigation Sidebar',
    name: 'Activities Blue',
    size: 'medium'
  },
  'main-navbar-activities-dark': {
    file: 'main_navbar/activities_dark.svg',
    group: 'Main Navigation Sidebar',
    name: 'Activities Dark',
    size: 'medium'
  },
  'main-navbar-activities-light': {
    file: 'main_navbar/activities_light.svg',
    group: 'Main Navigation Sidebar',
    name: 'Activities Light',
    size: 'medium'
  },
  'main-navbar-badges-cce': {
    file: 'main_navbar/badges/badges_cce.svg',
    group: 'Main Navigation Sidebar',
    name: 'Badges CCE',
    size: 'xs'
  },
  'main-navbar-badges-dcl': {
    file: 'main_navbar/badges/badges_dcl.svg',
    group: 'Main Navigation Sidebar',
    name: 'Badges DCL',
    size: 'xs'
  },
  'main-navbar-badges-el': {
    file: 'main_navbar/badges/badges_el.svg',
    group: 'Main Navigation Sidebar',
    name: 'Badges EL',
    size: 'xs'
  },
  'main-navbar-badges-flocabulary': {
    file: 'main_navbar/badges/badges_flocabulary.svg',
    group: 'Main Navigation Sidebar',
    name: 'Badges Flocabulary',
    size: 'xs'
  },
  'main-navbar-badges-hpl': {
    file: 'main_navbar/badges/badges_hpl.svg',
    group: 'Main Navigation Sidebar',
    name: 'Badges HPL',
    size: 'xs'
  },
  'main-navbar-badges-ll': {
    file: 'main_navbar/badges/badges_ll.svg',
    group: 'Main Navigation Sidebar',
    name: 'Badges LL',
    size: 'xs'
  },
  'main-navbar-badges-no-logo': {
    file: 'main_navbar/badges/badges_no_logo.svg',
    group: 'Main Navigation Sidebar',
    name: 'Badges No Logo',
    size: 'xs'
  },
  'main-navbar-badges-sel': {
    file: 'main_navbar/badges/badges_sel.svg',
    group: 'Main Navigation Sidebar',
    name: 'Badges SEL',
    size: 'xs'
  },
  'main-navbar-district-library-default': {
    file: 'main_navbar/district_library_default.svg',
    group: 'Main Navigation Sidebar',
    name: 'District Library Default',
    size: 'xs'
  },
  'main-navbar-district-library-disabled': {
    file: 'main_navbar/district_library_disabled.svg',
    group: 'Main Navigation Sidebar',
    name: 'District Library Disabled',
    size: 'xs'
  },
  'main-navbar-district-library-hover': {
    file: 'main_navbar/district_library_hover.svg',
    group: 'Main Navigation Sidebar',
    name: 'District Library Hover',
    size: 'xs'
  },
  'main-navbar-google-slides': {
    file: 'main_navbar/google_slides.svg',
    group: 'Main Navigation Sidebar',
    name: 'Google Slides',
    size: 'medium'
  },
  'main-navbar-hamburger': {
    file: 'main_navbar/hamburger.svg',
    group: 'Main Navigation Sidebar',
    name: 'Hamburger',
    size: 'medium'
  },
  'main-navbar-hamburger-hover': {
    file: 'main_navbar/hamburger_hover.svg',
    group: 'Main Navigation Sidebar',
    name: 'Hamburger Hover',
    size: 'medium'
  },
  'main-navbar-home-blue': {
    file: 'main_navbar/home_blue.svg',
    group: 'Main Navigation Sidebar',
    name: 'Home Blue',
    size: 'xs'
  },
  'main-navbar-home-dark': {
    file: 'main_navbar/home_dark.svg',
    group: 'Main Navigation Sidebar',
    name: 'Home Dark',
    size: 'xs'
  },
  'main-navbar-home-light': {
    file: 'main_navbar/home_light.svg',
    group: 'Main Navigation Sidebar',
    name: 'Home Light',
    size: 'xs'
  },
  'main-navbar-institution-library-xs': {
    file: 'main_navbar/institution_library.svg',
    group: 'Main Navigation Sidebar',
    name: 'Institution Library XS',
    size: 'xs'
  },
  'main-navbar-license-details': {
    file: 'main_navbar/license_details.svg',
    group: 'Main Navigation Sidebar',
    name: 'License Details',
    size: 'large'
  },
  'main-navbar-manage-account': {
    file: 'main_navbar/manage_account.svg',
    group: 'Main Navigation Sidebar',
    name: 'Manage Account',
    size: 'large'
  },
  'main-navbar-manage-dashboard': {
    file: 'main_navbar/manage_dashboard.svg',
    group: 'Main Navigation Sidebar',
    name: 'Manage Dashboard',
    size: 'large'
  },
  'main-navbar-math-district-district-libraries': {
    file: 'main_navbar/math_district/district_libraries.svg',
    group: 'Main Navigation Sidebar',
    name: 'District Libraries',
    size: 'large'
  },
  'main-navbar-math-district-lesson-availability': {
    file: 'main_navbar/math_district/lesson_availability.svg',
    group: 'Main Navigation Sidebar',
    name: 'Lesson Availability',
    size: 'large'
  },
  'main-navbar-math-district-manage-district-grey': {
    file: 'main_navbar/math_district/manage_district_grey.svg',
    group: 'Main Navigation Sidebar',
    name: 'Manage District Grey',
    size: 'large'
  },
  'main-navbar-math-district-manage-district-white': {
    file: 'main_navbar/math_district/manage_district_white.svg',
    group: 'Main Navigation Sidebar',
    name: 'Manage District White',
    size: 'large'
  },
  'main-navbar-math-district-manage-lessons': {
    file: 'main_navbar/math_district/manage_lessons.svg',
    group: 'Main Navigation Sidebar',
    name: 'Manage Lessons',
    size: 'large'
  },
  'main-navbar-math-district-manage-schools-grey': {
    file: 'main_navbar/math_district/manage_schools_grey.svg',
    group: 'Main Navigation Sidebar',
    name: 'Manage Schools Grey',
    size: 'large'
  },
  'main-navbar-math-district-manage-schools-white': {
    file: 'main_navbar/math_district/manage_schools_white.svg',
    group: 'Main Navigation Sidebar',
    name: 'Manage Schools White',
    size: 'large'
  },
  'main-navbar-math-district-manage-users-grey': {
    file: 'main_navbar/math_district/manage_users_grey.svg',
    group: 'Main Navigation Sidebar',
    name: 'Manage Users Grey',
    size: 'large'
  },
  'main-navbar-math-district-manage-users-white': {
    file: 'main_navbar/math_district/manage_users_white.svg',
    group: 'Main Navigation Sidebar',
    name: 'Manage Users White',
    size: 'large'
  },
  'main-navbar-math-district-post-session-reports': {
    file: 'main_navbar/math_district/post_session_reports.svg',
    group: 'Main Navigation Sidebar',
    name: 'Post Sessions Reports',
    size: 'large'
  },
  'main-navbar-math-district-school-libraries': {
    file: 'main_navbar/math_district/school_libraries.svg',
    group: 'Main Navigation Sidebar',
    name: 'School Libraries',
    size: 'large'
  },
  'main-navbar-math-district-share-lessons': {
    file: 'main_navbar/math_district/share_lessons.svg',
    group: 'Main Navigation Sidebar',
    name: 'Share Lessons',
    size: 'small'
  },
  'main-navbar-math-district-usage-graphs-grey': {
    file: 'main_navbar/math_district/usage_graphs_grey.svg',
    group: 'Main Navigation Sidebar',
    name: 'Usage Graphs Grey',
    size: 'large'
  },
  'main-navbar-math-district-usage-graphs-white': {
    file: 'main_navbar/math_district/usage_graphs_white.svg',
    group: 'Main Navigation Sidebar',
    name: 'Usage Graphs White',
    size: 'large'
  },
  'main-navbar-math-district-usage-statistics-grey': {
    file: 'main_navbar/math_district/usage_statistics_grey.svg',
    group: 'Main Navigation Sidebar',
    name: 'Usage Statistics Grey',
    size: 'large'
  },
  'main-navbar-math-district-usage-statistics-white': {
    file: 'main_navbar/math_district/usage_statistics_white.svg',
    group: 'Main Navigation Sidebar',
    name: 'Usage Statistics White',
    size: 'large'
  },
  'main-navbar-math-district-view-usage': {
    file: 'main_navbar/math_district/view_usage.svg',
    group: 'Main Navigation Sidebar',
    name: 'View Usage',
    size: 'large'
  },
  'main-navbar-public-library-default': {
    file: 'main_navbar/public_library_default.svg',
    group: 'Main Navigation Sidebar',
    name: 'Public Library Default',
    size: 'xs'
  },
  'main-navbar-public-library-disabled': {
    file: 'main_navbar/public_library_disabled.svg',
    group: 'Main Navigation Sidebar',
    name: 'Public Library Disabled',
    size: 'xs'
  },
  'main-navbar-public-library-hover': {
    file: 'main_navbar/public_library_hover.svg',
    group: 'Main Navigation Sidebar',
    name: 'Public Library Hover',
    size: 'xs'
  },
  'main-navbar-reports-blue': {
    file: 'main_navbar/reports_blue.svg',
    group: 'Main Navigation Sidebar',
    name: 'Reports Blue',
    size: 'xs'
  },
  'main-navbar-reports-dark': {
    file: 'main_navbar/reports_dark.svg',
    group: 'Main Navigation Sidebar',
    name: 'Reports Dark',
    size: 'xs'
  },
  'main-navbar-reports-light': {
    file: 'main_navbar/reports_light.svg',
    group: 'Main Navigation Sidebar',
    name: 'Reports Light',
    size: 'xs'
  },
  'main-navbar-school-library-default': {
    file: 'main_navbar/school_library_default.svg',
    group: 'Main Navigation Sidebar',
    name: 'School Library Default',
    size: 'xs'
  },
  'main-navbar-school-library-disabled': {
    file: 'main_navbar/school_library_disabled.svg',
    group: 'Main Navigation Sidebar',
    name: 'School Library Disabled',
    size: 'xs'
  },
  'main-navbar-school-library-hover': {
    file: 'main_navbar/school_library_hover.svg',
    group: 'Main Navigation Sidebar',
    name: 'School Library Hover',
    size: 'xs'
  },
  'main-navbar-search-default': {
    file: 'main_navbar/search_default.svg',
    group: 'Main Navigation Sidebar',
    name: 'Search Default',
    size: 'xs'
  },
  'main-navbar-search-disabled': {
    file: 'main_navbar/search_disabled.svg',
    group: 'Main Navigation Sidebar',
    name: 'Search Disabled',
    size: 'xs'
  },
  'main-navbar-search-hover': {
    file: 'main_navbar/search_hover.svg',
    group: 'Main Navigation Sidebar',
    name: 'Search Hover',
    size: 'xs'
  },
  'main-navbar-search': {
    file: 'main_navbar/search.svg',
    group: 'Main Navigation Sidebar',
    name: 'Search',
    size: 'small'
  },
  'main-navbar-subplans-blue': {
    file: 'main_navbar/subplans_blue.svg',
    group: 'Main Navigation Sidebar',
    name: 'Subplans Blue',
    size: 'xs'
  },
  'main-navbar-subplans-dark': {
    file: 'main_navbar/subplans_dark.svg',
    group: 'Main Navigation Sidebar',
    name: 'Subplans Dark',
    size: 'xs'
  },
  'main-navbar-subplans-light': {
    file: 'main_navbar/subplans_light.svg',
    group: 'Main Navigation Sidebar',
    name: 'Subplans Light',
    size: 'xs'
  },
  'main-navbar-teacher-resources-blue': {
    file: 'main_navbar/teacher_resources_blue.svg',
    group: 'Main Navigation Sidebar',
    name: 'Teacher Resources Blue',
    size: 'xs'
  },
  'main-navbar-teacher-resources-dark': {
    file: 'main_navbar/teacher_resources_dark.svg',
    group: 'Main Navigation Sidebar',
    name: 'Teacher Resources Dark',
    size: 'xs'
  },
  'main-navbar-teacher-resources-white': {
    file: 'main_navbar/teacher_resources_white.svg',
    group: 'Main Navigation Sidebar',
    name: 'Teacher Resources White',
    size: 'xs'
  },
  'main-navbar-video-blue': {
    file: 'main_navbar/video_blue.svg',
    group: 'Main Navigation Sidebar',
    name: 'Video Blue',
    size: 'medium'
  },
  'main-navbar-video-dark': {
    file: 'main_navbar/video_dark.svg',
    group: 'Main Navigation Sidebar',
    name: 'Video Dark',
    size: 'medium'
  },
  'main-navbar-video-grey': {
    file: 'main_navbar/video_grey.svg',
    group: 'Main Navigation Sidebar',
    name: 'Video Grey',
    size: 'medium'
  },
  'my-account-advance-settings': {
    file: 'my_account/advance_settings.svg',
    group: 'My Account',
    name: 'Advance Settings',
    size: 'xs'
  },
  'my-account-attach-file': {
    file: 'my_account/attach_file.svg',
    group: 'My Account',
    name: 'Attach File',
    size: 'small'
  },
  'my-account-avatar': {
    file: 'my_account/avatar.svg',
    group: 'My Account',
    name: 'Avatar',
    size: 'large'
  },
  'my-account-badges-district': {
    file: 'my_account/badges_district.svg',
    group: 'My Account',
    name: 'Badges District',
    size: 'large'
  },
  'my-account-badges-gold': {
    file: 'my_account/badges_gold.svg',
    group: 'My Account',
    name: 'Badges Gold',
    size: 'large'
  },
  'my-account-badges-platinum': {
    file: 'my_account/badges_platinum.svg',
    group: 'My Account',
    name: 'Badges Platinum',
    size: 'large'
  },
  'my-account-badges-school': {
    file: 'my_account/badges_school.svg',
    group: 'My Account',
    name: 'Badges School',
    size: 'large'
  },
  'my-account-badges-silver': {
    file: 'my_account/badges_silver.svg',
    group: 'My Account',
    name: 'Badges Silver',
    size: 'large'
  },
  'my-account-button-collapse': {
    file: 'my_account/button_collapse.svg',
    group: 'My Account',
    name: 'Button Collapse',
    size: 'xs'
  },
  'my-account-button-expand': {
    file: 'my_account/button_expand.svg',
    group: 'My Account',
    name: 'Button Expand',
    size: 'xs'
  },
  'my-account-contact-blue': {
    file: 'my_account/contact_blue.svg',
    group: 'My Account',
    name: 'Contact Blue',
    size: 'small'
  },
  'my-account-contact-dark': {
    file: 'my_account/contact_dark.svg',
    group: 'My Account',
    name: 'Contact Dark',
    size: 'small'
  },
  'my-account-contact-light': {
    file: 'my_account/contact_light.svg',
    group: 'My Account',
    name: 'Contact Light',
    size: 'small'
  },
  'my-account-create-subplan-big-grey': {
    file: 'my_account/create_subplan_big_grey.svg',
    group: 'My Account',
    name: 'Create Subplan Big Grey',
    size: 'large'
  },
  'my-account-create-subplan-big-white': {
    file: 'my_account/create_subplan_big_white.svg',
    group: 'My Account',
    name: 'Create Subplan Big White',
    size: 'medium'
  },
  'my-account-create-subplan-small-purple': {
    file: 'my_account/create_subplan_small_purple.svg',
    group: 'My Account',
    name: 'Create Subplan Small Purple',
    size: 'small'
  },
  'my-account-credit-card-blue': {
    file: 'my_account/credit_card_blue.svg',
    group: 'My Account',
    name: 'Credit Card Blue',
    size: 'xs'
  },
  'my-account-credit-card-grey': {
    file: 'my_account/credit_card_grey.svg',
    group: 'My Account',
    name: 'Credit Card Grey',
    size: 'xs'
  },
  'my-account-credit-card-white': {
    file: 'my_account/credit_card_white.svg',
    group: 'My Account',
    name: 'Credit Card White',
    size: 'xs'
  },
  'my-account-date-picker-blue': {
    file: 'my_account/date_picker_blue.svg',
    group: 'My Account',
    name: 'Date Picker Blue',
    size: 'medium'
  },
  'my-account-date-picker-dark': {
    file: 'my_account/date_picker_dark.svg',
    group: 'My Account',
    name: 'Date Picker Dark',
    size: 'medium'
  },
  'my-account-date-picker-light': {
    file: 'my_account/date_picker_light.svg',
    group: 'My Account',
    name: 'Date Picker Light',
    size: 'medium'
  },
  'my-account-fields-envelope-default': {
    file: 'my_account/envelope.svg',
    group: 'My Account',
    name: 'Envelope for Input Fields',
    size: 'default'
  },
  'my-account-faq': {
    file: 'my_account/faq.svg',
    group: 'My Account',
    name: 'FAQ',
    size: 'medium'
  },
  'my-account-faq-xs': {
    file: 'my_account/faq_xs.svg',
    group: 'My Account',
    name: 'FAQ xs',
    size: 'xs'
  },
  'my-account-help-blue': {
    file: 'my_account/help_blue.svg',
    group: 'My Account',
    name: 'Help Blue',
    size: 'small'
  },
  'my-account-help-dark': {
    file: 'my_account/help_dark.svg',
    group: 'My Account',
    name: 'Help Dark',
    size: 'small'
  },
  'my-account-help-light': {
    file: 'my_account/help_light.svg',
    group: 'My Account',
    name: 'Help Light',
    size: 'small'
  },
  'my-account-infinite-storage': {
    file: 'my_account/infinite_storage.svg',
    group: 'My Account',
    name: 'Infinite Storage',
    size: 'small'
  },
  'my-account-fields-lock-default': {
    file: 'my_account/lock.svg',
    group: 'My Account',
    name: 'Lock for Input Fields',
    size: 'default'
  },
  'my-account-fields-lock-darker': {
    file: 'my_account/lock-darker.svg',
    group: 'My Account',
    name: 'Darker lock for Input Fields',
    size: 'default'
  },
  'my-account-nearpod-blog-blue': {
    file: 'my_account/nearpod_blog_blue.svg',
    group: 'My Account',
    name: 'Nearpod Blog Blue',
    size: 'small'
  },
  'my-account-nearpod-blog-dark': {
    file: 'my_account/nearpod_blog_dark.svg',
    group: 'My Account',
    name: 'Nearpod Blog Dark',
    size: 'small'
  },
  'my-account-nearpod-blog-light': {
    file: 'my_account/nearpod_blog_light.svg',
    group: 'My Account',
    name: 'Nearpod Blog Light',
    size: 'small'
  },
  'my-account-notifications-blue': {
    file: 'my_account/notifications_blue.svg',
    group: 'My Account',
    name: 'Notifications Blue',
    size: 'small'
  },
  'my-account-notifications-dark': {
    file: 'my_account/notifications_dark.svg',
    group: 'My Account',
    name: 'Notifications Dark',
    size: 'small'
  },
  'my-account-notifications-light': {
    file: 'my_account/notifications_light.svg',
    group: 'My Account',
    name: 'Notifications Light',
    size: 'small'
  },
  'my-account-fields-person-default': {
    file: 'my_account/person.svg',
    group: 'My Account',
    name: 'Person for Input Fields',
    size: 'default'
  },
  'my-account-profile-pic-cam': {
    file: 'my_account/profile_pic_cam.svg',
    group: 'My Account',
    name: 'Profile Pic Cam',
    size: 'medium'
  },
  'my-account-profile-pic-cam-dark': {
    file: 'my_account/profile_pic_cam_dark.svg',
    group: 'My Account',
    name: 'Profile Pic Cam Dark',
    size: 'medium'
  },
  'my-account-profile-pic-cam-light': {
    file: 'my_account/profile_pic_cam_light.svg',
    group: 'My Account',
    name: 'Profile Pic Cam Light',
    size: 'medium'
  },
  'my-account-search-small': {
    file: 'my_account/search.svg',
    group: 'My Account',
    name: 'Search Small',
    size: 'small'
  },
  'my-account-settings-blue': {
    file: 'my_account/settings_blue.svg',
    group: 'My Account',
    name: 'Settings Blue',
    size: 'medium'
  },
  'my-account-settings-dark': {
    file: 'my_account/settings_dark.svg',
    group: 'My Account',
    name: 'Settings Dark',
    size: 'medium'
  },
  'my-account-settings-light': {
    file: 'my_account/settings_light.svg',
    group: 'My Account',
    name: 'Settings Light',
    size: 'medium'
  },
  'my-account-fields-star-default': {
    file: 'my_account/star.svg',
    group: 'My Account',
    name: 'Star for Input Fields',
    size: 'default'
  },
  'my-account-subplans-blue': {
    file: 'my_account/subplans_blue.svg',
    group: 'My Account',
    name: 'Subplans Blue',
    size: 'small'
  },
  'my-account-sso-provider-apple-default': {
    file: 'my_account/apple-icon.svg',
    group: 'My Account',
    name: 'SSO Provider Apple Link Icon',
    size: 'default'
  },
  'my-account-sso-provider-classlink-default': {
    file: 'my_account/classlink-icon.svg',
    group: 'My Account',
    name: 'SSO Provider Class Link Icon',
    size: 'default'
  },
  'my-account-sso-provider-clever-default': {
    file: 'my_account/clever-icon.svg',
    group: 'My Account',
    name: 'SSO Provider Clever Icon',
    size: 'default'
  },
  'my-account-sso-provider-google-default': {
    file: 'my_account/google-icon.svg',
    group: 'My Account',
    name: 'SSO Provider Google Icon',
    size: 'default'
  },
  'my-account-sso-provider-office365-default': {
    file: 'my_account/office365-icon.svg',
    group: 'My Account',
    name: 'SSO Provider Office 365 Icon',
    size: 'default'
  },
  'my-account-subplans-dark': {
    file: 'my_account/subplans_dark.svg',
    group: 'My Account',
    name: 'Subplans Dark',
    size: 'small'
  },
  'my-account-subplans-light': {
    file: 'my_account/subplans_light.svg',
    group: 'My Account',
    name: 'Subplans Light',
    size: 'small'
  },
  'my-account-upgrade-blue-big': {
    file: 'my_account/upgrade_blue_big.svg',
    group: 'My Account',
    name: 'Upgrade Blue Big',
    size: 'medium'
  },
  'my-account-upgrade-blue-small': {
    file: 'my_account/upgrade_blue_small.svg',
    group: 'My Account',
    name: 'Upgrade Blue Small',
    size: 'small'
  },
  'my-account-upgrade-dark-big': {
    file: 'my_account/upgrade_dark_big.svg',
    group: 'My Account',
    name: 'Upgrade Dark Big',
    size: 'medium'
  },
  'my-account-upgrade-dark-small': {
    file: 'my_account/upgrade_dark_small.svg',
    group: 'My Account',
    name: 'Upgrade Dark Small',
    size: 'small'
  },
  'my-account-upgrade-light-big': {
    file: 'my_account/upgrade_light_big.svg',
    group: 'My Account',
    name: 'Upgrade Light Big',
    size: 'medium'
  },
  'my-account-upgrade-light-small': {
    file: 'my_account/upgrade_light_small.svg',
    group: 'My Account',
    name: 'Upgrade Light Small',
    size: 'small'
  },
  'my-account-user-blue': {
    file: 'my_account/user_blue.svg',
    group: 'My Account',
    name: 'User Blue',
    size: 'small'
  },
  'my-account-user-dark': {
    file: 'my_account/user_dark.svg',
    group: 'My Account',
    name: 'User Dark',
    size: 'small'
  },
  'my-account-user-light': {
    file: 'my_account/user_light.svg',
    group: 'My Account',
    name: 'User Light',
    size: 'small'
  },
  'my-lessons-add-to-folder-or-library-blue': {
    file: 'my_lessons/add_to_folder_or_library_blue.svg',
    group: 'My Lessons',
    name: 'Add to Folder or Library Blue',
    size: 'small'
  },
  'my-lessons-add-to-folder-or-library-default': {
    file: 'my_lessons/add_to_folder_or_library_default.svg',
    group: 'My Lessons',
    name: 'Add to Folder or Library Default',
    size: 'small'
  },
  'my-lessons-avatar': {
    file: 'my_lessons/avatar.svg',
    group: 'My Lessons',
    name: 'Avatar',
    size: 'default'
  },
  'my-lessons-breadcrumb': {
    file: 'my_lessons/breadcrumb.svg',
    group: 'My Lessons',
    name: 'Breadcrumb',
    size: 'small'
  },
  'my-lessons-delete-lesson-default': {
    file: 'my_lessons/delete_lesson_default.svg',
    group: 'My Lessons',
    name: 'Delete Lesson Default',
    size: 'small'
  },
  'my-lessons-delete-lesson-hover': {
    file: 'my_lessons/delete_lesson_hover.svg',
    group: 'My Lessons',
    name: 'Delete Lesson Hover',
    size: 'small'
  },
  'my-lessons-drag-dark-default': {
    file: 'my_lessons/drag_dark_default.svg',
    group: 'My Lessons',
    name: 'Drag Dark Default',
    size: 'small'
  },
  'my-lessons-drag-dark-disabled': {
    file: 'my_lessons/drag_dark_disabled.svg',
    group: 'My Lessons',
    name: 'Drag Dark Disabled',
    size: 'small'
  },
  'my-lessons-drag-dark-hover': {
    file: 'my_lessons/drag_dark_hover.svg',
    group: 'My Lessons',
    name: 'Drag Dark Hover',
    size: 'small'
  },
  'my-lessons-drag-light-default': {
    file: 'my_lessons/drag_light_default.svg',
    group: 'My Lessons',
    name: 'Drag Light Default',
    size: 'small'
  },
  'my-lessons-duplicate-lesson-default': {
    file: 'my_lessons/duplicate_lesson_default.svg',
    group: 'My Lessons',
    name: 'Duplicate Lesson Default',
    size: 'small'
  },
  'my-lessons-duplicate-lesson-hover': {
    file: 'my_lessons/duplicate_lesson_hover.svg',
    group: 'My Lessons',
    name: 'Duplicate Lesson Hover',
    size: 'small'
  },
  'my-lessons-edit-lesson-alternative': {
    file: 'my_lessons/edit_lesson_alternative.svg',
    group: 'My Lessons',
    name: 'Edit Lesson Alternative',
    size: 'medium'
  },
  'my-lessons-edit-lesson-default': {
    file: 'my_lessons/edit_lesson_default.svg',
    group: 'My Lessons',
    name: 'Edit Lesson Default',
    size: 'medium'
  },
  'my-lessons-edit-lesson-hover': {
    file: 'my_lessons/edit_lesson_hover.svg',
    group: 'My Lessons',
    name: 'Edit Lesson Hover',
    size: 'medium'
  },
  'my-lessons-folder': {
    file: 'my_lessons/folder.svg',
    group: 'My Lessons',
    name: 'Folder',
    size: 'small'
  },
  'my-lessons-folder-blue-50-small': {
    file: 'my_lessons/folder_blue.svg',
    group: 'My Lessons',
    name: 'Folder blue',
    size: 'small'
  },
  'my-lessons-folder-blue-50-medium': {
    file: 'my_lessons/folder_blue.svg',
    group: 'My Lessons',
    name: 'Folder blue',
    size: 'medium'
  },
  'my-lessons-folder-blue-50-xs': {
    file: 'my_lessons/folder_blue.svg',
    group: 'My Lessons',
    name: 'Folder blue',
    size: 'xs'
  },
  'my-lessons-folder-customization-blue-70-small': {
    file: 'my_lessons/folder_customization_blue_70.svg',
    group: 'My Lessons',
    name: 'Folder Customization blue 70',
    size: 'small'
  },
  'my-lessons-folder-customization-blue-70-medium': {
    file: 'my_lessons/folder_customization_blue_70.svg',
    group: 'My Lessons',
    name: 'Folder Customization blue 70',
    size: 'medium'
  },
  'my-lessons-folder-customization-blue-70-xs': {
    file: 'my_lessons/folder_customization_blue_70.svg',
    group: 'My Lessons',
    name: 'Folder Customization blue 70',
    size: 'xs'
  },
  'my-lessons-folder-neutral-60-small': {
    file: 'my_lessons/folder_neutral_60.svg',
    group: 'My Lessons',
    name: 'Folder Neutral 60',
    size: 'small'
  },
  'my-lessons-folder-neutral-60-medium': {
    file: 'my_lessons/folder_neutral_60.svg',
    group: 'My Lessons',
    name: 'Folder Neutral 60',
    size: 'medium'
  },
  'my-lessons-folder-neutral-60-xs': {
    file: 'my_lessons/folder_neutral_60.svg',
    group: 'My Lessons',
    name: 'Folder Neutral 60',
    size: 'xs'
  },
  'my-lessons-folder-mint-50-xs': {
    file: 'my_lessons/folder_mint.svg',
    group: 'My Lessons',
    name: 'Folder Mint',
    size: 'xs'
  },
  'my-lessons-folder-mint-50-small': {
    file: 'my_lessons/folder_mint.svg',
    group: 'My Lessons',
    name: 'Folder Mint',
    size: 'small'
  },
  'my-lessons-folder-mint-50-medium': {
    file: 'my_lessons/folder_mint.svg',
    group: 'My Lessons',
    name: 'Folder Mint',
    size: 'medium'
  },
  'my-lessons-folder-customization-purple-30-small': {
    file: 'my_lessons/folder_customization_purple_30.svg',
    group: 'My Lessons',
    name: 'Folder Customization purple 30',
    size: 'small'
  },
  'my-lessons-folder-customization-purple-30-medium': {
    file: 'my_lessons/folder_customization_purple_30.svg',
    group: 'My Lessons',
    name: 'Folder Customization purple 30',
    size: 'medium'
  },
  'my-lessons-folder-customization-purple-30-xs': {
    file: 'my_lessons/folder_customization_purple_30.svg',
    group: 'My Lessons',
    name: 'Folder Customization purple 30',
    size: 'xs'
  },
  'my-lessons-folder-customization-blue-30-small': {
    file: 'my_lessons/folder_customization_blue_30.svg',
    group: 'My Lessons Customization blue 30',
    name: 'Folder Customization Blue 30',
    size: 'small'
  },
  'my-lessons-folder-customization-blue-30-medium': {
    file: 'my_lessons/folder_customization_blue_30.svg',
    group: 'My Lessons Customization blue 30',
    name: 'Folder Customization Blue 30',
    size: 'medium'
  },
  'my-lessons-folder-customization-blue-30-xs': {
    file: 'my_lessons/folder_customization_blue_30.svg',
    group: 'My Lessons Customization blue 30',
    name: 'Folder Customization Blue 30',
    size: 'xs'
  },
  'my-lessons-folder-customization-green-30-small': {
    file: 'my_lessons/folder_customization_green_30.svg',
    group: 'My Lessons',
    name: 'Folder Customization green 30',
    size: 'small'
  },
  'my-lessons-folder-customization-green-30-medium': {
    file: 'my_lessons/folder_customization_green_30.svg',
    group: 'My Lessons',
    name: 'Folder Customization green 30',
    size: 'medium'
  },
  'my-lessons-folder-customization-green-30-xs': {
    file: 'my_lessons/folder_customization_green_30.svg',
    group: 'My Lessons',
    name: 'Folder Customization green 30',
    size: 'xs'
  },
  'my-lessons-folder-customization-yellow-30-small': {
    file: 'my_lessons/folder_customization_yellow_30.svg',
    group: 'My Lessons',
    name: 'Folder Customization Yellow 30',
    size: 'small'
  },
  'my-lessons-folder-customization-yellow-30-medium': {
    file: 'my_lessons/folder_customization_yellow_30.svg',
    group: 'My Lessons',
    name: 'Folder Customization Yellow 30',
    size: 'medium'
  },
  'my-lessons-folder-customization-yellow-30-xs': {
    file: 'my_lessons/folder_customization_yellow_30.svg',
    group: 'My Lessons',
    name: 'Folder Customization Yellow 30',
    size: 'xs'
  },
  'my-lessons-folder-customization-pink-small': {
    file: 'my_lessons/folder_customization_pink.svg',
    group: 'My Lessons',
    name: 'Folder pink',
    size: 'small'
  },
  'my-lessons-folder-customization-pink-medium': {
    file: 'my_lessons/folder_customization_pink.svg',
    group: 'My Lessons',
    name: 'Folder pink',
    size: 'medium'
  },
  'my-lessons-folder-customization-pink-xs': {
    file: 'my_lessons/folder_customization_pink.svg',
    group: 'My Lessons',
    name: 'Folder pink',
    size: 'xs'
  },
  'my-lessons-folder-purple-50-small': {
    file: 'my_lessons/folder_purple.svg',
    group: 'My Lessons',
    name: 'Folder purple',
    size: 'small'
  },
  'my-lessons-folder-purple-50-medium': {
    file: 'my_lessons/folder_purple.svg',
    group: 'My Lessons',
    name: 'Folder purple',
    size: 'medium'
  },
  'my-lessons-folder-purple-50-xs': {
    file: 'my_lessons/folder_purple.svg',
    group: 'My Lessons',
    name: 'Folder purple',
    size: 'xs'
  },
  'my-lessons-folder-blush-50-small': {
    file: 'my_lessons/folder_blush.svg',
    group: 'My Lessons',
    name: 'Folder Blush',
    size: 'small'
  },
  'my-lessons-folder-blush-50-medium': {
    file: 'my_lessons/folder_blush.svg',
    group: 'My Lessons',
    name: 'Folder Blush',
    size: 'medium'
  },
  'my-lessons-folder-blush-50-xs': {
    file: 'my_lessons/folder_blush.svg',
    group: 'My Lessons',
    name: 'Folder Blush',
    size: 'xs'
  },
  'my-lessons-folder-saffron-50-small': {
    file: 'my_lessons/folder_saffron.svg',
    group: 'My Lessons',
    name: 'Folder Saffron',
    size: 'small'
  },
  'my-lessons-folder-saffron-50-medium': {
    file: 'my_lessons/folder_saffron.svg',
    group: 'My Lessons',
    name: 'Folder Saffron',
    size: 'medium'
  },
  'my-lessons-folder-saffron-50-xs': {
    file: 'my_lessons/folder_saffron.svg',
    group: 'My Lessons',
    name: 'Folder Saffron',
    size: 'xs'
  },
  'my-lessons-add-folder-blue-border-small': {
    file: 'my_lessons/create_new_folder_blue_borders.svg',
    group: 'My Lessons',
    name: 'Add Folder',
    size: 'small'
  },
  'my-lessons-add-folder-white-border-small': {
    file: 'my_lessons/create_new_folder_white_border.svg',
    group: 'My Lessons',
    name: 'Add Folder',
    size: 'small'
  },
  'my-lessons-add-folder-white-border-xs': {
    file: 'my_lessons/create_new_folder_white_border.svg',
    group: 'My Lessons',
    name: 'Add Folder',
    size: 'xs'
  },
  'my-lessons-add-folder-centered-blue-border-small': {
    file: 'my_lessons/add_folder_plus_centered_blue_border.svg',
    group: 'My Lessons',
    name: 'Add Folder',
    size: 'small'
  },
  'my-lessons-add-folder-gray-small': {
    file: 'my_lessons/create_new_folder_gray.svg',
    group: 'My Lessons',
    name: 'Add Folder',
    size: 'small'
  },
  'my-lessons-add-folder-gray-xs': {
    file: 'my_lessons/create_new_folder_gray.svg',
    group: 'My Lessons',
    name: 'Add Folder',
    size: 'xs'
  },
  'my-lessons-folder-big-add-disabled': {
    file: 'my_lessons/folder_big_add_disabled.svg',
    group: 'My Lessons',
    name: 'Folder Big Add Disabled',
    size: 'medium'
  },
  'my-lessons-folder-big-delete-default': {
    file: 'my_lessons/folder_big_delete_default.svg',
    group: 'My Lessons',
    name: 'Folder Big Delete Default',
    size: 'medium'
  },
  'my-lessons-folder-color-default': {
    file: 'my_lessons/folder_color_default.svg',
    group: 'My Lessons',
    name: 'Folder Color Default',
    size: 'small'
  },
  'my-lessons-folder-color-disabled': {
    file: 'my_lessons/folder_color_disabled.svg',
    group: 'My Lessons',
    name: 'Folder Color Disabled',
    size: 'small'
  },
  'my-lessons-folder-color-hover': {
    file: 'my_lessons/folder_color_hover.svg',
    group: 'My Lessons',
    name: 'Folder Color Hover',
    size: 'small'
  },
  'my-lessons-folder-small-default-default': {
    file: 'my_lessons/folder_small_default_default.svg',
    group: 'My Lessons',
    name: 'Folder Small Default Default',
    size: 'medium'
  },
  'my-lessons-lesson-blue': {
    file: 'my_lessons/lesson_blue.svg',
    group: 'My Lessons',
    name: 'Lesson Blue',
    size: 'small'
  },
  'my-lessons-lesson-dark': {
    file: 'my_lessons/lesson_dark.svg',
    group: 'My Lessons',
    name: 'Lesson Dark',
    size: 'small'
  },
  'my-lessons-lesson-light': {
    file: 'my_lessons/lesson_light.svg',
    group: 'My Lessons',
    name: 'Lesson Light',
    size: 'small'
  },
  'my-lessons-lesson-light-xs': {
    file: 'my_lessons/lesson_light_xs.svg',
    group: 'My Lessons',
    name: 'Lesson Light Xs',
    size: 'xs'
  },
  'my-lessons-lesson-light-red-xs': {
    file: 'my_lessons/lesson_light_xs_red.svg',
    group: 'My Lessons Red',
    name: 'Lesson Light Red Xs',
    size: 'xs'
  },
  'my-lessons-live-default-blue': {
    file: 'my_lessons/live_lesson_default_blue.svg',
    group: 'My Lessons',
    name: 'Live Lesson Default Blue',
    size: 'small'
  },
  'my-lessons-menu-dotted-big-default': {
    file: 'my_lessons/menu_dotted_big_default.svg',
    group: 'My Lessons',
    name: 'Menu Dotted Big Default',
    size: 'medium'
  },
  'my-lessons-menu-dotted-big-hover': {
    file: 'my_lessons/menu_dotted_big_hover.svg',
    group: 'My Lessons',
    name: 'Menu Dotted Big Hover',
    size: 'medium'
  },
  'my-lessons-menu-gray-dotted-small-default': {
    file: 'my_lessons/menu_dotted_gray_default.svg',
    group: 'My Lessons',
    name: 'Menu Dotted Large Default',
    size: 'small'
  },
  'my-lessons-menu-gray-dotted-small-hover': {
    file: 'my_lessons/menu_dotted_gray_hover.svg',
    group: 'My Lessons',
    name: 'Menu Dotted Large Hover',
    size: 'small'
  },
  'my-lessons-menu-gray-dotted-small-selected': {
    file: 'my_lessons/menu_dotted_gray_hover.svg',
    group: 'My Lessons',
    name: 'Menu Dotted Large Selected',
    size: 'small'
  },
  'my-lessons-menu-dotted-small-default': {
    file: 'my_lessons/menu_dotted_small_default.svg',
    group: 'My Lessons',
    name: 'Menu Dotted Small Default',
    size: 'medium'
  },
  'my-lessons-menu-dotted-small-disabled': {
    file: 'my_lessons/menu_dotted_small_disabled.svg',
    group: 'My Lessons',
    name: 'Menu Dotted Small Disabled',
    size: 'medium'
  },
  'my-lessons-menu-dotted-small-hover': {
    file: 'my_lessons/menu_dotted_small_hover.svg',
    group: 'My Lessons',
    name: 'Menu Dotted Small Hover',
    size: 'medium'
  },
  'my-lessons-menu-dotted-gray-xs-default': {
    file: 'my_lessons/menu_dotted_gray_default.svg',
    group: 'My Lessons',
    name: 'Menu Dotted Gray XS Default',
    size: 'xs'
  },
  'my-lessons-menu-dotted-gray-small-default': {
    file: 'my_lessons/menu_dotted_gray_default.svg',
    group: 'My Lessons',
    name: 'Menu Dotted Gray Small Default',
    size: 'small'
  },
  'my-lessons-menu-dotted-gray-xs-hover': {
    file: 'my_lessons/menu_dotted_gray_hover.svg',
    group: 'My Lessons',
    name: 'Menu Dotted Gray XS Hover',
    size: 'xs'
  },
  'my-lessons-menu-dotted-gray-xs-selected': {
    file: 'my_lessons/menu_dotted_gray_selected.svg',
    group: 'My Lessons',
    name: 'Menu Dotted Gray XS Selected',
    size: 'xs'
  },
  'my-lessons-quick-launch-default-blue': {
    file: 'my_lessons/quick_launch_default_blue.svg',
    group: 'My Lessons',
    name: 'Quick Launch Default Blue',
    size: 'small'
  },
  'my-lessons-quick-launch-default-white': {
    file: 'my_lessons/quick_launch_default_white.svg',
    group: 'My Lessons',
    name: 'Quick Launch Default White',
    size: 'small'
  },
  'my-lessons-quick-launch-default-grey': {
    file: 'my_lessons/quick_launch_default_grey.svg',
    group: 'My Lessons',
    name: 'Quick Launch Default Grey',
    size: 'small'
  },
  'my-lessons-quick-launch-disabled': {
    file: 'my_lessons/quick_launch_disabled.svg',
    group: 'My Lessons',
    name: 'Quick Launch Disabled',
    size: 'small'
  },
  'my-lessons-quick-launch-hover': {
    file: 'my_lessons/quick_launch_hover.svg',
    group: 'My Lessons',
    name: 'Quick Launch Hover',
    size: 'small'
  },
  'my-lessons-share-lesson-default': {
    file: 'my_lessons/share_lesson_default.svg',
    group: 'My Lessons',
    name: 'Share Lesson Default',
    size: 'small'
  },
  'my-lessons-share-lesson-disabled': {
    file: 'my_lessons/share_lesson_disabled.svg',
    group: 'My Lessons',
    name: 'Share Lesson Disabled',
    size: 'small'
  },
  'my-lessons-share-lesson-hover': {
    file: 'my_lessons/share_lesson_hover.svg',
    group: 'My Lessons',
    name: 'Share Lesson Hover',
    size: 'small'
  },
  'my-lessons-share-lesson-white': {
    file: 'my_lessons/share_lesson_white.svg',
    group: 'My Lessons',
    name: 'Share Lesson White',
    size: 'small'
  },
  'my-lessons-share-lesson-white-hover': {
    file: 'my_lessons/share_lesson_white_hover.svg',
    group: 'My Lessons',
    name: 'Share Lesson White Hover',
    size: 'small'
  },
  'my-lessons-showhide-hide-default': {
    file: 'my_lessons/showhide_hide_default.svg',
    group: 'My Lessons',
    name: 'Show / Hide - Hide Default',
    size: 'medium'
  },
  'my-lessons-showhide-hide-disabled': {
    file: 'my_lessons/showhide_hide_disabled.svg',
    group: 'My Lessons',
    name: 'Show / Hide - Hide Disabled',
    size: 'medium'
  },
  'my-lessons-showhide-hide-hover': {
    file: 'my_lessons/showhide_hide_hover.svg',
    group: 'My Lessons',
    name: 'Show / Hide - Hide Hover',
    size: 'medium'
  },
  'my-lessons-showhide-show-default': {
    file: 'my_lessons/showhide_show_default.svg',
    group: 'My Lessons',
    name: 'Show / Hide - Show Default',
    size: 'medium'
  },
  'my-lessons-showhide-show-disabled': {
    file: 'my_lessons/showhide_show_disabled.svg',
    group: 'My Lessons',
    name: 'Show / Hide - Show Disabled',
    size: 'medium'
  },
  'my-lessons-showhide-show-hover': {
    file: 'my_lessons/showhide_show_hover.svg',
    group: 'My Lessons',
    name: 'Show / Hide - Show Hover',
    size: 'medium'
  },
  'my-lessons-preview-default': {
    file: 'my_lessons/preview_default.svg',
    group: 'My Lessons',
    name: 'Preview - Default',
    size: 'medium'
  },
  'my-lessons-preview-hover': {
    file: 'my_lessons/preview_hover.svg',
    group: 'My Lessons',
    name: 'Preview - Hover',
    size: 'medium'
  },
  'my-lessons-compass': {
    file: 'my_lessons/compass.svg',
    group: 'My Lessons',
    name: 'Compass',
    size: 'default'
  },
  'my-lessons-small-compass': {
    file: 'my_lessons/compass.svg',
    group: 'My Lessons',
    name: 'Small Compass',
    size: 'xs'
  },
  'my-lessons-small-blue-compass': {
    file: 'my_lessons/compass_blue.svg',
    group: 'My Lessons',
    name: 'Small Blue Compass',
    size: 'xs'
  },
  'my-lessons-student-paced-default-yellow': {
    file: 'my_lessons/student_paced_default_yellow.svg',
    group: 'My Lessons',
    name: 'Student Paced Default Yellow',
    size: 'small'
  },
  'my-lessons-add-folder-default': {
    file: 'my_lessons/add_folder_big.svg',
    group: 'My Lessons',
    name: 'Add Folder',
    size: 'small'
  },
  'my-lessons-add-folder-hover': {
    file: 'my_lessons/add_folder_big_hover.svg',
    group: 'My Lessons',
    name: 'Add Folder - Hover',
    size: 'small'
  },
  'my-lessons-make-unavailable-dark': {
    file: 'my_lessons/make_unavailable_dark.svg',
    group: 'My Lessons',
    name: 'Make Unavailable Dark',
    size: 'xs'
  },
  'my-lessons-add-to-district-xs': {
    file: 'my_lessons/add_to_district.svg',
    group: 'My Lessons',
    name: 'Add to district',
    size: 'xs'
  },
  'my-lessons-add-to-school-xs': {
    file: 'my_lessons/add_to_school.svg',
    group: 'My Lessons',
    name: 'Add to school',
    size: 'xs'
  },
  'my-lessons-add-lessons-xs': {
    file: 'my_lessons/add_lessons.svg',
    group: 'My Lessons',
    name: 'Add lesson',
    size: 'xs'
  },
  'my-lessons-color-fill-xs': {
    file: 'my_lessons/color_fill.svg',
    group: 'My Lessons',
    name: 'Color fill',
    size: 'xs'
  },
  'my-lessons-create-new-folder-xs': {
    file: 'my_lessons/create_new_folder.svg',
    group: 'My Lessons',
    name: 'Create new folder',
    size: 'xs'
  },
  'my-lessons-delete-xs-default': {
    file: 'my_lessons/delete.svg',
    group: 'My Lessons',
    name: 'Delete',
    size: 'xs'
  },
  'my-lessons-delete-small-default': {
    file: 'my_lessons/delete.svg',
    group: 'My Lessons',
    name: 'Delete small',
    size: 'small'
  },
  'my-lessons-delete-xs-hover': {
    file: 'my_lessons/delete_blue.svg',
    group: 'My Lessons',
    name: 'Delete',
    size: 'xs'
  },
  'my-lessons-move-xs': {
    file: 'my_lessons/move.svg',
    group: 'My Lessons',
    name: 'Move',
    size: 'xs'
  },
  'my-lessons-edit-pencil-xs': {
    file: 'my_lessons/edit.svg',
    group: 'My Lessons',
    name: 'Edit',
    size: 'xs'
  },
  'my-lessons-share-xs': {
    file: 'my_lessons/share.svg',
    group: 'My Lessons',
    name: 'Share',
    size: 'xs'
  },
  'my-lessons-share-group-xs': {
    file: 'my_lessons/share-group.svg',
    group: 'My Lessons',
    name: 'Share Group',
    size: 'xs'
  },
  'my-lessons-open-in-a-new-tab-xs': {
    file: 'my_lessons/open_in_new.svg',
    group: 'My Lessons',
    name: 'Open in a new tab',
    size: 'xs'
  },
  'my-lessons-copy-xs': {
    file: 'my_lessons/content_copy.svg',
    group: 'My Lessons',
    name: 'Copy',
    size: 'xs'
  },
  'my-lessons-copy-small': {
    file: 'my_lessons/content_copy.svg',
    group: 'My Lessons',
    name: 'Copy small',
    size: 'small'
  },
  'my-lessons-copy-dotted': {
    file: 'my_lessons/content_copy_dotted.svg',
    group: 'My Lessons',
    name: 'Copy dotted',
    size: 'default'
  },
  'my-lessons-copy-dotted-white': {
    file: 'my_lessons/content_copy_dotted_white.svg',
    group: 'My Lessons',
    name: 'Copy dotted white',
    size: 'default'
  },
  'my-lessons-share-close': {
    file: 'my_lessons/share_close.svg',
    group: 'My Lessons',
    name: 'Share close',
    size: 'default'
  },
  'my-lessons-duplicate-xs': {
    file: 'my_lessons/content_duplicate.svg',
    group: 'My Lessons',
    name: 'Duplicate',
    size: 'xs'
  },
  'my-lessons-report-xs': {
    file: 'my_lessons/news.svg',
    group: 'My Lessons',
    name: 'Copy / Duplicate',
    size: 'xs'
  },
  'my-lessons-export-to-pdf-xs': {
    file: 'my_lessons/picture_as_pdf.svg',
    group: 'My Lessons',
    name: 'Export to PDF',
    size: 'xs'
  },
  'my-lessons-group-xs': {
    file: 'my_lessons/group.svg',
    group: 'My Lessons',
    name: 'Group',
    size: 'xs'
  },
  'my-lessons-home-xs': {
    file: 'my_lessons/home.svg',
    group: 'My Lessons',
    name: 'Group',
    size: 'xs'
  },
  'my-lessons-done-xs': {
    file: 'my_lessons/done.svg',
    group: 'My Lessons',
    name: 'Done',
    size: 'xs'
  },
  'my-lessons-check-white-xs': {
    file: 'my_lessons/check_white.svg',
    group: 'My Lessons',
    name: 'Done',
    size: 'xs'
  },
  'my-lessons-check-black-xs': {
    file: 'my_lessons/check_black.svg',
    group: 'My Lessons',
    name: 'Done',
    size: 'xs'
  },
  'my-lessons-user-shared-lesson-owner-default': {
    file: 'my_lessons/user-shared-lesson-owner-default.svg',
    group: 'My Lessons',
    name: 'User Shared Lesson Owner',
    size: 'default'
  },
  'my-lessons-visibility-white-xs-default': {
    file: 'my_lessons/visibility_white.svg',
    group: 'My Lessons',
    name: 'Visibility Eye',
    size: 'xs'
  },
  'my-lessons-visibility-white-xs-hover': {
    file: 'my_lessons/visibility_blue.svg',
    group: 'My Lessons',
    name: 'Visibility Eye',
    size: 'xs'
  },
  'my-lessons-visibility-xs-default': {
    file: 'my_lessons/visibility_default.svg',
    group: 'My Lessons',
    name: 'Visibility Eye',
    size: 'xs'
  },
  'my-lessons-visibility-small-default': {
    file: 'my_lessons/visibility_default.svg',
    group: 'My Lessons',
    name: 'Visibility Eye small',
    size: 'small'
  },
  'my-lessons-visibility-xs-hover': {
    file: 'my_lessons/visibility_blue.svg',
    group: 'My Lessons',
    name: 'Visibility Eye',
    size: 'xs'
  },
  'my-lessons-edit-white-xs-default': {
    file: 'my_lessons/edit_white.svg',
    group: 'My Lessons',
    name: 'Edit pencil',
    size: 'xs'
  },
  'my-lessons-edit-white-xs-hover': {
    file: 'my_lessons/edit_blue.svg',
    group: 'My Lessons',
    name: 'Edit pencil',
    size: 'xs'
  },
  'my-lessons-delete-white-xs-default': {
    file: 'my_lessons/delete_white.svg',
    group: 'My Lessons',
    name: 'Delete',
    size: 'xs'
  },
  'my-lessons-delete-white-xs-hover': {
    file: 'my_lessons/delete_blue.svg',
    group: 'My Lessons',
    name: 'Delete',
    size: 'xs'
  },
  'my-lessons-arrow-right-rounded-small': {
    file: 'my_lessons/arrow_right_rounded.svg',
    group: 'My Lessons',
    name: 'Arrow Right Rounded',
    size: 'small'
  },
  'my-lessons-expand-more-rounded-small': {
    file: 'my_lessons/expand_more_rounded.svg',
    group: 'My Lessons',
    name: 'Expand more rounded',
    size: 'small'
  },
  'my-lessons-meatball-small-default': {
    file: 'my_lessons/meatball_default.svg',
    group: 'My Lessons',
    name: 'Menu meatball',
    size: 'small'
  },
  'my-lessons-meatball-large-default': {
    file: 'my_lessons/meatball_default.svg',
    group: 'My Lessons',
    name: 'Menu meatball',
    size: 'large'
  },
  'my-lessons-meatball-white-xs-default': {
    file: 'my_lessons/meatball_white.svg',
    group: 'My Lessons',
    name: 'Menu meatball',
    size: 'xs'
  },
  'my-lessons-meatball-white-small-default': {
    file: 'my_lessons/meatball_white.svg',
    group: 'My Lessons',
    name: 'Menu meatball',
    size: 'small'
  },
  'my-lessons-meatball-white-large-default': {
    file: 'my_lessons/meatball_white.svg',
    group: 'My Lessons',
    name: 'Menu meatball',
    size: 'large'
  },
  'my-lessons-meatball-small-hover': {
    file: 'my_lessons/meatball_blue.svg',
    group: 'My Lessons',
    name: 'Menu meatball',
    size: 'small'
  },
  'my-lessons-meatball-white-medium-hover': {
    file: 'my_lessons/meatball_blue.svg',
    group: 'My Lessons',
    name: 'Menu meatball',
    size: 'medium'
  },
  'my-lessons-meatball-large-hover': {
    file: 'my_lessons/meatball_blue.svg',
    group: 'My Lessons',
    name: 'Menu meatball',
    size: 'large'
  },
  'my-lessons-meatball-white-large-hover': {
    file: 'my_lessons/meatball_blue.svg',
    group: 'My Lessons',
    name: 'Menu meatball',
    size: 'large'
  },
  'my-lessons-meatball-white-medium-default': {
    file: 'my_lessons/meatball_white.svg',
    group: 'My Lessons',
    name: 'Menu meatball',
    size: 'medium'
  },
  'my-lessons-meatball-medium-hover': {
    file: 'my_lessons/meatball_blue.svg',
    group: 'My Lessons',
    name: 'Menu meatball',
    size: 'medium'
  },
  'my-lessons-folder-kebab-large-default': {
    file: 'my_lessons/kebab_default.svg',
    group: 'My Lessons',
    name: 'Kebab Menu',
    size: 'large'
  },
  'my-lessons-folder-kebab-large-hover': {
    file: 'my_lessons/kebab_blue.svg',
    group: 'My Lessons',
    name: 'Kebab Menu',
    size: 'large'
  },
  'my-lessons-rocket-white-xs': {
    file: 'my_lessons/rocket_white.svg',
    group: 'My Lessons',
    name: 'Rocket (Quick Launch)',
    size: 'xs'
  },
  'my-lessons-rocket-white-medium-narrow': {
    file: 'my_lessons/rocket_white.svg',
    group: 'My Lessons',
    name: 'Rocket (Quick Launch)',
    size: 'medium-narrow'
  },
  'my-lessons-lock-xs': {
    file: 'my_lessons/lock.svg',
    group: 'My Lessons',
    name: 'Lock',
    size: 'xs'
  },
  'my-lessons-unavailable-xs': {
    file: 'my_lessons/unavailable.svg',
    group: 'My Lessons',
    name: 'Unavailable',
    size: 'xs'
  },
  'my-lessons-toolbar-book-small': {
    file: 'my_lessons/bottom_toolbar/book.svg',
    group: 'My Lesson',
    name: 'Book',
    size: 'small'
  },
  'my-lessons-toolbar-chevron-backward-small': {
    file: 'my_lessons/bottom_toolbar/chevron_backward.svg',
    group: 'My Lesson',
    name: 'Chevron Backward',
    size: 'small'
  },
  'my-lessons-toolbar-chevron-forward-small': {
    file: 'my_lessons/bottom_toolbar/chevron_forward.svg',
    group: 'My Lesson',
    name: 'Chevron Forward',
    size: 'small'
  },
  'my-lessons-toolbar-share-small': {
    file: 'my_lessons/bottom_toolbar/share.svg',
    group: 'My Lesson',
    name: 'share',
    size: 'small'
  },
  'my-lessons-toolbar-windows-small': {
    file: 'my_lessons/bottom_toolbar/windows.svg',
    group: 'My Lesson',
    name: 'Windows',
    size: 'small'
  },
  'my-lessons-play-white-xs': {
    file: 'my_lessons/play_circle_white.svg',
    group: 'My Lesson',
    name: 'Play circle white',
    size: 'xs'
  },
  'my-lessons-play-white-medium-narrow': {
    file: 'my_lessons/play_circle_white.svg',
    group: 'My Lesson',
    name: 'Play circle white',
    size: 'medium-narrow'
  },
  'my-lessons-youtube-xs': {
    file: 'my_lessons/youtube.svg',
    group: 'My Lesson',
    name: 'Youtube',
    size: 'xs'
  },
  'my-lessons-youtube-black-medium-narrow': {
    file: 'my_lessons/youtube_black.svg',
    group: 'My Lesson',
    name: 'Youtube Black',
    size: 'medium-narrow'
  },
  'my-lessons-move-white-xs': {
    file: 'my_lessons/move_white.svg',
    group: 'My Lesson',
    name: 'Move',
    size: 'xs'
  },
  'my-lessons-add-to-district-library': {
    file: 'my_lessons/add_to_district_library.svg',
    group: 'My Lessons',
    name: 'Add to district Library',
    size: 'xs'
  },
  'my-lessons-add-to-school-library': {
    file: 'my_lessons/add_to_school_library.svg',
    group: 'My Lessons',
    name: 'Add to school Library',
    size: 'xs'
  },
  'my-lessons-make-unavailable': {
    file: 'my_lessons/make_unavailable.svg',
    group: 'My Lessons',
    name: 'Make Unavailable',
    size: 'xs'
  },
  'my-lessons-make-available': {
    file: 'my_lessons/make_available.svg',
    group: 'My Lessons',
    name: 'Make Available',
    size: 'xs'
  },
  'my-lessons-make-available-dark': {
    file: 'my_lessons/make_available_dark.svg',
    group: 'My Lessons',
    name: 'Make Available Dark',
    size: 'xs'
  },
  'my-lesson-gallery-add-activity': {
    file: 'my_lesson_gallery/add_activity.svg',
    group: 'My Lesson Gallery',
    name: 'Add Activity',
    size: 'xs'
  },
  'my-lesson-gallery-add-content': {
    file: 'my_lesson_gallery/add_content.svg',
    group: 'My Lesson Gallery',
    name: 'Add Content',
    size: 'xs'
  },
  'my-lesson-gallery-add-l': {
    file: 'my_lesson_gallery/add_l.svg',
    group: 'My Lesson Gallery',
    name: 'Add L',
    size: 'large'
  },
  'my-lesson-gallery-add-m': {
    file: 'my_lesson_gallery/add_m.svg',
    group: 'My Lesson Gallery',
    name: 'Add M',
    size: 'medium'
  },
  'my-lesson-gallery-add-s': {
    file: 'my_lesson_gallery/add_s.svg',
    group: 'My Lesson Gallery',
    name: 'Add S',
    size: 'small'
  },
  'my-lesson-gallery-subtract_s': {
    file: 'my_lesson_gallery/subtract_s.svg',
    group: 'My Lesson Gallery',
    name: 'Subtract S',
    size: 'small'
  },
  'my-lesson-gallery-add-slide': {
    file: 'my_lesson_gallery/add_slide.svg',
    group: 'My Lesson Gallery',
    name: 'Add Slide',
    size: 'xs'
  },
  'my-lesson-gallery-add-xl': {
    file: 'my_lesson_gallery/add_xl.svg',
    group: 'My Lesson Gallery',
    name: 'Add XL',
    size: 'large'
  },
  'my-lesson-gallery-add-xs': {
    file: 'my_lesson_gallery/add_xs.svg',
    group: 'My Lesson Gallery',
    name: 'Add XS',
    size: 'xs'
  },
  'my-lesson-gallery-add-xs-grey': {
    file: 'my_lesson_gallery/add_xs_grey.svg',
    group: 'My Lesson Gallery',
    name: 'Add XS Grey',
    size: 'xs'
  },
  'my-lesson-gallery-add-xxs': {
    file: 'my_lesson_gallery/add_xxs.svg',
    group: 'My Lesson Gallery',
    name: 'Add XXS',
    size: 'xs'
  },
  'my-lesson-gallery-checkmark': {
    file: 'my_lesson_gallery/checkmark.svg',
    group: 'My Lesson Gallery',
    name: 'Checkmark',
    size: 'xs'
  },
  'my-lesson-gallery-copy-slides-big-default': {
    file: 'my_lesson_gallery/copy_slides_big_default.svg',
    group: 'My Lesson Gallery',
    name: 'Copy Slides Big Default',
    size: 'large'
  },
  'my-lesson-gallery-copy-slides-medium-default': {
    file: 'my_lesson_gallery/copy_slides_small_default.svg',
    group: 'My Lesson Gallery',
    name: 'Copy Slides Medium Default',
    size: 'medium'
  },
  'my-lesson-gallery-copy-slides-medium-disabled': {
    file: 'my_lesson_gallery/copy_slides_small_disabled.svg',
    group: 'My Lesson Gallery',
    name: 'Copy Slides Medium Disabled',
    size: 'medium'
  },
  'my-lesson-gallery-copy-slides-small-default': {
    file: 'my_lesson_gallery/copy_slides_small_default.svg',
    group: 'My Lesson Gallery',
    name: 'Copy Slides Small Default',
    size: 'small'
  },
  'my-lesson-gallery-copy-slides-small-disabled': {
    file: 'my_lesson_gallery/copy_slides_small_disabled.svg',
    group: 'My Lesson Gallery',
    name: 'Copy Slides Small Disabled',
    size: 'small'
  },
  'my-lesson-gallery-copy-slides-small-hover': {
    file: 'my_lesson_gallery/copy_slides_small_hover.svg',
    group: 'My Lesson Gallery',
    name: 'Copy Slides Small Hover',
    size: 'small'
  },
  'my-lesson-gallery-delete-default': {
    file: 'my_lesson_gallery/delete_default.svg',
    group: 'My Lesson Gallery',
    name: 'Delete Default',
    size: 'small'
  },
  'my-lesson-gallery-delete-blue': {
    file: 'my_lesson_gallery/delete_blue.svg',
    group: 'My Lesson Gallery',
    name: 'Delete Blue',
    size: 'small'
  },
  'my-lesson-gallery-delete-disabled': {
    file: 'my_lesson_gallery/delete_disabled.svg',
    group: 'My Lesson Gallery',
    name: 'Delete Disabled',
    size: 'small'
  },
  'my-lesson-gallery-delete-hover': {
    file: 'my_lesson_gallery/delete_hover.svg',
    group: 'My Lesson Gallery',
    name: 'Delete Hover',
    size: 'small'
  },
  'my-lesson-gallery-delete-red-hover-default': {
    file: 'my_lesson_gallery/delete_default.svg',
    group: 'My Lesson Gallery',
    name: 'Delete Red Default',
    size: 'small'
  },
  'my-lesson-gallery-delete-red-hover-hover': {
    file: 'my_lesson_gallery/delete_hover_red.svg',
    group: 'My Lesson Gallery',
    name: 'Delete Red Hover',
    size: 'small'
  },
  'my-lesson-gallery-duplicate-question-default': {
    file: 'my_lesson_gallery/duplicate_question_default.svg',
    group: 'My Lesson Gallery',
    name: 'Duplicate Question Default',
    size: 'small'
  },
  'my-lesson-gallery-duplicate-question-disabled': {
    file: 'my_lesson_gallery/duplicate_question_disabled.svg',
    group: 'My Lesson Gallery',
    name: 'Duplicate Question Disabled',
    size: 'small'
  },
  'my-lesson-gallery-duplicate-question-hover': {
    file: 'my_lesson_gallery/duplicate_question_hover.svg',
    group: 'My Lesson Gallery',
    name: 'Duplicate Question Hover',
    size: 'small'
  },
  'my-lesson-gallery-duplicate-slide-lesson-default': {
    file: 'my_lesson_gallery/duplicate_slide_lesson_default.svg',
    group: 'My Lesson Gallery',
    name: 'Duplicate Slide Lesson Default',
    size: 'small'
  },
  'my-lesson-gallery-duplicate-slide-lesson-hover': {
    file: 'my_lesson_gallery/duplicate_slide_lesson_hover.svg',
    group: 'My Lesson Gallery',
    name: 'Duplicate Slide Lesson Hover',
    size: 'small'
  },
  'my-lesson-gallery-paste-big-default': {
    file: 'my_lesson_gallery/paste_big_default.svg',
    group: 'My Lesson Gallery',
    name: 'Paste Big Default',
    size: 'large'
  },
  'my-lesson-gallery-paste-medium-default': {
    file: 'my_lesson_gallery/paste_small_default.svg',
    group: 'My Lesson Gallery',
    name: 'Paste Medium Default',
    size: 'medium'
  },
  'my-lesson-gallery-paste-medium-disabled': {
    file: 'my_lesson_gallery/paste_small_disabled.svg',
    group: 'My Lesson Gallery',
    name: 'Paste Medium Disabled',
    size: 'medium'
  },
  'my-lesson-gallery-paste-small-default': {
    file: 'my_lesson_gallery/paste_small_default.svg',
    group: 'My Lesson Gallery',
    name: 'Paste Small Default',
    size: 'small'
  },
  'my-lesson-gallery-paste-small-disabled': {
    file: 'my_lesson_gallery/paste_small_disabled.svg',
    group: 'My Lesson Gallery',
    name: 'Paste Small Disabled',
    size: 'small'
  },
  'my-lesson-gallery-paste-small-hover': {
    file: 'my_lesson_gallery/paste_small_hover.svg',
    group: 'My Lesson Gallery',
    name: 'Paste Small Hover',
    size: 'small'
  },
  'my-lesson-gallery-settings-lesson-details-default': {
    file: 'my_lesson_gallery/settings_lesson_details_default.svg',
    group: 'My Lesson Gallery',
    name: 'Settings Lesson Details Default',
    size: 'small'
  },
  'my-lesson-gallery-settings-lesson-details-xs-default': {
    file: 'my_lesson_gallery/settings_lesson_details_xs_default.svg',
    group: 'My Lesson Gallery',
    name: 'Settings Lesson Details xs Default',
    size: 'default'
  },
  'my-lesson-gallery-settings-lesson-details-xs-hover': {
    file: 'my_lesson_gallery/settings_lesson_details_xs_hover.svg',
    group: 'My Lesson Gallery',
    name: 'Settings Lesson Details xs Hover',
    size: 'default'
  },
  'my-lesson-gallery-settings-lesson-details-default-alternative': {
    file: 'my_lesson_gallery/settings_lesson_details_default_alternative.svg',
    group: 'My Lesson Gallery',
    name: 'Settings Lesson Details Default Alternative',
    size: 'medium'
  },
  'my-lesson-gallery-settings-lesson-details-default-alternative-sm': {
    file: 'my_lesson_gallery/settings_lesson_details_default_alternative_sm.svg',
    group: 'My Lesson Gallery',
    name: 'Settings Lesson Details Default Alternative small',
    size: 'small'
  },
  'my-lesson-gallery-settings-lesson-details-disabled': {
    file: 'my_lesson_gallery/settings_lesson_details_disabled.svg',
    group: 'My Lesson Gallery',
    name: 'Settings Lesson Details Disabled',
    size: 'small'
  },
  'my-lesson-gallery-settings-lesson-details-hover': {
    file: 'my_lesson_gallery/settings_lesson_details_hover.svg',
    group: 'My Lesson Gallery',
    name: 'Settings Lesson Details Hover',
    size: 'small'
  },
  'my-lesson-gallery-settings-lesson-details-gray-hover-default': {
    file: 'my_lesson_gallery/settings_lesson_details_default.svg',
    group: 'My Lesson Gallery',
    name: 'Settings Lesson Details Gray Default',
    size: 'small'
  },
  'my-lesson-gallery-settings-lesson-details-gray-hover-hover': {
    file: 'my_lesson_gallery/settings_lesson_details_hover_gray.svg',
    group: 'My Lesson Gallery',
    name: 'Settings Lesson Details Gray Hover',
    size: 'small'
  },
  'my-lesson-gallery-add-dark-blue-xs': {
    file: 'my_lesson_gallery/add_dark_blue.svg',
    group: 'My Lesson Gallery',
    name: 'Add + Dark Blue',
    size: 'xs'
  },
  'my-lesson-gallery-add-white-xs': {
    file: 'my_lesson_gallery/add_white.svg',
    group: 'My Lesson Gallery',
    name: 'Add + ',
    size: 'xs'
  },
  'my-lesson-gallery-add-white-small': {
    file: 'my_lesson_gallery/add_white.svg',
    group: 'My Lesson Gallery',
    name: 'Add +',
    size: 'small'
  },
  'reports-check-correct-answer-dark': {
    file: 'reports/check_correct_answer_dark.svg',
    group: 'Reports',
    name: 'Check Correct Answer Dark',
    size: 'xs'
  },
  'reports-check-correct-answer-green': {
    file: 'reports/check_correct_answer_green.svg',
    group: 'Reports',
    name: 'Check Correct Answer Green',
    size: 'xs'
  },
  'reports-check-correct-answer-light': {
    file: 'reports/check_correct_answer_light.svg',
    group: 'Reports',
    name: 'Check Correct Answer Light',
    size: 'xs'
  },
  'reports-check-mark-select-option': {
    file: 'reports/check_mark_select_option.svg',
    group: 'Reports',
    name: 'Check Mark Select Option',
    size: 'default'
  },
  'reports-check-neutral-answer-dark': {
    file: 'reports/check_neutral_answer_dark.svg',
    group: 'Reports',
    name: 'Check Neutral Answer Dark',
    size: 'xs'
  },
  'reports-csv': {
    file: 'reports/csv.svg',
    group: 'Reports',
    name: 'CSV',
    size: 'small'
  },
  'reports-download': {
    file: 'reports/download.svg',
    group: 'Reports',
    name: 'Download',
    size: 'large'
  },
  'reports-google-drive-xs': {
    file: 'reports/google_drive_icon.svg',
    group: 'Reports',
    name: 'Google drive',
    size: 'xs'
  },
  'reports-google-drive-small': {
    file: 'reports/google_drive_icon.svg',
    group: 'Reports',
    name: 'Google drive',
    size: 'small'
  },
  'reports-warning-xs': {
    file: 'reports/warning_icon.svg',
    group: 'Reports',
    name: 'Warning',
    size: 'xs'
  },
  'reports-warning-small': {
    file: 'reports/warning_icon.svg',
    group: 'Reports',
    name: 'Warning',
    size: 'small'
  },
  'reports-image-inspect-xs': {
    file: 'reports/image_inspect_icon.svg',
    group: 'Reports',
    name: 'Image Inspect',
    size: 'xs'
  },
  'reports-image-inspect-small': {
    file: 'reports/image_inspect_icon.svg',
    group: 'Reports',
    name: 'Image Inspect',
    size: 'small'
  },
  'reports-table-arrow-xs': {
    file: 'reports/table_arrow_icon.svg',
    group: 'Reports',
    name: 'Table arrow',
    size: 'xs'
  },
  'reports-table-arrow-small': {
    file: 'reports/table_arrow_icon.svg',
    group: 'Reports',
    name: 'Table arrow',
    size: 'small'
  },
  'reports-wrong-icon-red-xs': {
    file: 'reports/wrong_red_icon.svg',
    group: 'Reports',
    name: 'Wrong',
    size: 'xs'
  },
  'reports-wrong-icon-red-small': {
    file: 'reports/wrong_red_icon.svg',
    group: 'Reports',
    name: 'Wrong',
    size: 'small'
  },
  'reports-edit': {
    file: 'reports/edit.svg',
    group: 'Reports',
    name: 'Edit',
    size: 'small'
  },
  'reports-edit-pencil-default': {
    file: 'reports/edit_pencil_default.svg',
    group: 'Reports',
    name: 'Edit Pencil Default',
    size: 'small'
  },
  'reports-edit-pencil-hover': {
    file: 'reports/edit_pencil_hover.svg',
    group: 'Reports',
    name: 'Edit Pencil Hover',
    size: 'small'
  },
  'reports-list-view': {
    file: 'reports/list_view.svg',
    group: 'Reports',
    name: 'List View',
    size: 'xs'
  },
  'reports-no-answer': {
    file: 'reports/no_answer.svg',
    group: 'Reports',
    name: 'No Answer',
    size: 'xs'
  },
  'reports-participated': {
    file: 'reports/participated.svg',
    group: 'Reports',
    name: 'Participated',
    size: 'large'
  },
  'reports-post-session-reports-blue': {
    file: 'reports/post_session_reports_blue.svg',
    group: 'Reports',
    name: 'Post Session Reports Blue',
    size: 'large'
  },
  'reports-post-session-reports-dark': {
    file: 'reports/post_session_reports_dark.svg',
    group: 'Reports',
    name: 'Post Session Reports Dark',
    size: 'default'
  },
  'reports-post-session-reports-default': {
    file: 'reports/post_session_reports_default.svg',
    group: 'Reports',
    name: 'Post Session Reports Default',
    size: 'large'
  },
  'reports-post-session-reports-hover': {
    file: 'reports/post_session_reports_hover.svg',
    group: 'Reports',
    name: 'Post Session Reports Hover',
    size: 'large'
  },
  'reports-reports-blue': {
    file: 'reports/reports_blue.svg',
    group: 'Reports',
    name: 'Reports Blue',
    size: 'small'
  },
  'reports-reports-grey': {
    file: 'reports/reports_grey.svg',
    group: 'Reports',
    name: 'Reports Grey',
    size: 'small'
  },
  'reports-reports-modal': {
    file: 'reports/reports_modal.svg',
    group: 'Reports',
    name: 'Reports Modal',
    size: 'large'
  },
  'reports-share': {
    file: 'reports/share.svg',
    group: 'Reports',
    name: 'Share',
    size: 'large'
  },
  'reports-student': {
    file: 'reports/student.svg',
    group: 'Reports',
    name: 'Student',
    size: 'large'
  },
  'reports-students': {
    file: 'reports/students.svg',
    group: 'Reports',
    name: 'Students',
    size: 'large'
  },
  'reports-wrong-answer': {
    file: 'reports/wrong_answer.svg',
    group: 'Reports',
    name: 'Wrong Answer',
    size: 'xs'
  },
  'reports-link-out-default': {
    file: 'reports/link_out_icon.svg',
    group: 'Reports',
    name: 'Link out',
    size: 'default'
  },
  'reports-link-out-xs': {
    file: 'reports/link_out_icon.svg',
    group: 'Reports',
    name: 'Link out',
    size: 'xs'
  },
  'reports-link-out-small': {
    file: 'reports/link_out_icon.svg',
    group: 'Reports',
    name: 'Link out',
    size: 'small'
  },
  'reports-back-xs': {
    file: 'reports/back_icon.svg',
    group: 'Reports',
    name: 'Back',
    size: 'xs'
  },
  'reports-back-small': {
    file: 'reports/back_icon.svg',
    group: 'Reports',
    name: 'Back',
    size: 'small'
  },
  'shapes-circle': {
    file: 'shapes/circle.svg',
    group: 'Shapes',
    name: 'Circle',
    size: 'small'
  },
  'shapes-rounded-square': {
    file: 'shapes/rounded_square.svg',
    group: 'Shapes',
    name: 'Rounded Square',
    size: 'small'
  },
  'search-neutral-xs-default': {
    file: 'system_ui/search_neutral_xs_default.svg',
    group: 'System UI',
    name: 'Search Neutral Default',
    size: 'xs'
  },
  'search-neutral-xs-hover': {
    file: 'system_ui/search_neutral_xs_hover.svg',
    group: 'System UI',
    name: 'Search Neutral Hover',
    size: 'xs'
  },
  'select-dropdown': {
    file: 'select/select-dropdown-icon.svg',
    group: 'Select',
    name: 'Dropdown',
    size: 'default'
  },
  'shapes-square': {
    file: 'shapes/square.svg',
    group: 'Shapes',
    name: 'Square',
    size: 'small'
  },
  'shapes-triangle': {
    file: 'shapes/triangle.svg',
    group: 'Shapes',
    name: 'Triangle',
    size: 'small'
  },
  'side-drawer-chevron': {
    file: 'side_drawer/side_drawer_chevron.svg',
    group: 'Side Drawer',
    name: 'Chevron',
    size: 'default'
  },
  'slide-editor-audio-default': {
    file: 'slide_editor/audio_default.svg',
    group: 'Slide Editor',
    name: 'Audio Default',
    size: 'medium'
  },
  'slide-editor-audio-hover': {
    file: 'slide_editor/audio_hover.svg',
    group: 'Slide Editor',
    name: 'Audio Hover',
    size: 'medium'
  },
  'slide-editor-audio-selected': {
    file: 'slide_editor/audio_selected.svg',
    group: 'Slide Editor',
    name: 'Audio Selected',
    size: 'medium'
  },
  'slide-editor-audio-disabled': {
    file: 'slide_editor/audio_disabled.svg',
    group: 'Slide Editor',
    name: 'Audio Disabled',
    size: 'medium'
  },
  'slide-editor-background-default': {
    file: 'slide_editor/background_default.svg',
    group: 'Slide Editor',
    name: 'Background Default',
    size: 'medium'
  },
  'slide-editor-background-hover': {
    file: 'slide_editor/background_hover.svg',
    group: 'Slide Editor',
    name: 'Background Hover',
    size: 'medium'
  },
  'slide-editor-background-selected': {
    file: 'slide_editor/background_selected.svg',
    group: 'Slide Editor',
    name: 'Background Selected',
    size: 'medium'
  },
  'slide-editor-background-disabled': {
    file: 'slide_editor/background_disabled.svg',
    group: 'Slide Editor',
    name: 'Background Disabled',
    size: 'medium'
  },
  'slide-editor-border-color-default': {
    file: 'slide_editor/border_color_default.svg',
    group: 'Slide Editor',
    name: 'Border Color Default',
    size: 'medium'
  },
  'slide-editor-border-color-hover': {
    file: 'slide_editor/border_color_hover.svg',
    group: 'Slide Editor',
    name: 'Border Color Hover',
    size: 'medium'
  },
  'slide-editor-border-color-selected': {
    file: 'slide_editor/border_color_selected.svg',
    group: 'Slide Editor',
    name: 'Border Color Selected',
    size: 'medium'
  },
  'slide-editor-border-color-disabled': {
    file: 'slide_editor/border_color_disabled.svg',
    group: 'Slide Editor',
    name: 'Border Color Disabled',
    size: 'medium'
  },
  'slide-editor-bring-to-front-default': {
    file: 'slide_editor/bring_to_front_default.svg',
    group: 'Slide Editor',
    name: 'Bring to Front Default',
    size: 'medium'
  },
  'slide-editor-bring-to-front-hover': {
    file: 'slide_editor/bring_to_front_hover.svg',
    group: 'Slide Editor',
    name: 'Bring to Front Hover',
    size: 'medium'
  },
  'slide-editor-bring-to-front-selected': {
    file: 'slide_editor/bring_to_front_selected.svg',
    group: 'Slide Editor',
    name: 'Bring to Front Selected',
    size: 'medium'
  },
  'slide-editor-bring-to-front-disabled': {
    file: 'slide_editor/bring_to_front_disabled.svg',
    group: 'Slide Editor',
    name: 'Bring to Front Disabled',
    size: 'medium'
  },
  'slide-editor-color-default': {
    file: 'slide_editor/color_default.svg',
    group: 'Slide Editor',
    name: 'Color Default',
    size: 'medium'
  },
  'slide-editor-color-hover': {
    file: 'slide_editor/color_hover.svg',
    group: 'Slide Editor',
    name: 'Color Hover',
    size: 'medium'
  },
  'slide-editor-color-selected': {
    file: 'slide_editor/color_selected.svg',
    group: 'Slide Editor',
    name: 'Color Selected',
    size: 'medium'
  },
  'slide-editor-color-disabled': {
    file: 'slide_editor/color_disabled.svg',
    group: 'Slide Editor',
    name: 'Color Disabled',
    size: 'medium'
  },
  'slide-editor-copy-default': {
    file: 'slide_editor/copy_default.svg',
    group: 'Slide Editor',
    name: 'Copy Default',
    size: 'medium'
  },
  'slide-editor-copy-hover': {
    file: 'slide_editor/copy_hover.svg',
    group: 'Slide Editor',
    name: 'Copy Hover',
    size: 'medium'
  },
  'slide-editor-copy-selected': {
    file: 'slide_editor/copy_selected.svg',
    group: 'Slide Editor',
    name: 'Copy Selected',
    size: 'medium'
  },
  'slide-editor-copy-disabled': {
    file: 'slide_editor/copy_disabled.svg',
    group: 'Slide Editor',
    name: 'Copy Disabled',
    size: 'medium'
  },
  'slide-editor-dash-default': {
    file: 'slide_editor/dash_default.svg',
    group: 'Slide Editor',
    name: 'Dash Default',
    size: 'medium'
  },
  'slide-editor-dash-hover': {
    file: 'slide_editor/dash_hover.svg',
    group: 'Slide Editor',
    name: 'Dash Hover',
    size: 'medium'
  },
  'slide-editor-dash-selected': {
    file: 'slide_editor/dash_selected.svg',
    group: 'Slide Editor',
    name: 'Dash Selected',
    size: 'medium'
  },
  'slide-editor-dash-disabled': {
    file: 'slide_editor/dash_disabled.svg',
    group: 'Slide Editor',
    name: 'Dash Disabled',
    size: 'medium'
  },
  'slide-editor-delete-default': {
    file: 'slide_editor/delete_default.svg',
    group: 'Slide Editor',
    name: 'Delete Default',
    size: 'medium'
  },
  'slide-editor-delete-hover': {
    file: 'slide_editor/delete_hover.svg',
    group: 'Slide Editor',
    name: 'Delete Hover',
    size: 'medium'
  },
  'slide-editor-delete-selected': {
    file: 'slide_editor/delete_selected.svg',
    group: 'Slide Editor',
    name: 'Delete Selected',
    size: 'medium'
  },
  'slide-editor-delete-disabled': {
    file: 'slide_editor/delete_disabled.svg',
    group: 'Slide Editor',
    name: 'Delete Disabled',
    size: 'medium'
  },
  'slide-editor-eraser-default': {
    file: 'slide_editor/eraser_default.svg',
    group: 'Slide Editor',
    name: 'Eraser Default',
    size: 'medium'
  },
  'slide-editor-eraser-hover': {
    file: 'slide_editor/eraser_hover.svg',
    group: 'Slide Editor',
    name: 'Eraser Hover',
    size: 'medium'
  },
  'slide-editor-eraser-selected': {
    file: 'slide_editor/eraser_selected.svg',
    group: 'Slide Editor',
    name: 'Eraser Selected',
    size: 'medium'
  },
  'slide-editor-eraser-disabled': {
    file: 'slide_editor/eraser_disabled.svg',
    group: 'Slide Editor',
    name: 'Eraser Disabled',
    size: 'medium'
  },
  'slide-editor-gif-default': {
    file: 'slide_editor/gif_default.svg',
    group: 'Slide Editor',
    name: 'Gif Default',
    size: 'medium'
  },
  'slide-editor-gif-hover': {
    file: 'slide_editor/gif_hover.svg',
    group: 'Slide Editor',
    name: 'Gif Hover',
    size: 'medium'
  },
  'slide-editor-gif-selected': {
    file: 'slide_editor/gif_selected.svg',
    group: 'Slide Editor',
    name: 'Gif Selected',
    size: 'medium'
  },
  'slide-editor-gif-disabled': {
    file: 'slide_editor/gif_disabled.svg',
    group: 'Slide Editor',
    name: 'Gif Disabled',
    size: 'medium'
  },
  'slide-editor-image-default': {
    file: 'slide_editor/image_default.svg',
    group: 'Slide Editor',
    name: 'Image Default',
    size: 'medium'
  },
  'slide-editor-image-hover': {
    file: 'slide_editor/image_hover.svg',
    group: 'Slide Editor',
    name: 'Image Hover',
    size: 'medium'
  },
  'slide-editor-image-selected': {
    file: 'slide_editor/image_selected.svg',
    group: 'Slide Editor',
    name: 'Image Selected',
    size: 'medium'
  },
  'slide-editor-image-disabled': {
    file: 'slide_editor/image_disabled.svg',
    group: 'Slide Editor',
    name: 'Image Disabled',
    size: 'medium'
  },
  'slide-editor-link-default': {
    file: 'slide_editor/link_default.svg',
    group: 'Slide Editor',
    name: 'Link Default',
    size: 'medium'
  },
  'slide-editor-link-hover': {
    file: 'slide_editor/link_hover.svg',
    group: 'Slide Editor',
    name: 'Link Hover',
    size: 'medium'
  },
  'slide-editor-link-selected': {
    file: 'slide_editor/link_selected.svg',
    group: 'Slide Editor',
    name: 'Link Selected',
    size: 'medium'
  },
  'slide-editor-link-disabled': {
    file: 'slide_editor/link_disabled.svg',
    group: 'Slide Editor',
    name: 'Link Disabled',
    size: 'medium'
  },
  'slide-editor-marker-default': {
    file: 'slide_editor/marker_default.svg',
    group: 'Slide Editor',
    name: 'Marker Default',
    size: 'medium'
  },
  'slide-editor-marker-hover': {
    file: 'slide_editor/marker_hover.svg',
    group: 'Slide Editor',
    name: 'Marker Hover',
    size: 'medium'
  },
  'slide-editor-marker-selected': {
    file: 'slide_editor/marker_selected.svg',
    group: 'Slide Editor',
    name: 'Marker Selected',
    size: 'medium'
  },
  'slide-editor-marker-disabled': {
    file: 'slide_editor/marker_disabled.svg',
    group: 'Slide Editor',
    name: 'Marker Disabled',
    size: 'medium'
  },
  'slide-editor-paste-default': {
    file: 'slide_editor/paste_default.svg',
    group: 'Slide Editor',
    name: 'Paste Default',
    size: 'medium'
  },
  'slide-editor-paste-hover': {
    file: 'slide_editor/paste_hover.svg',
    group: 'Slide Editor',
    name: 'Paste Hover',
    size: 'medium'
  },
  'slide-editor-paste-selected': {
    file: 'slide_editor/paste_selected.svg',
    group: 'Slide Editor',
    name: 'Paste Selected',
    size: 'medium'
  },
  'slide-editor-paste-disabled': {
    file: 'slide_editor/paste_disabled.svg',
    group: 'Slide Editor',
    name: 'Paste Disabled',
    size: 'medium'
  },
  'slide-editor-record-default': {
    file: 'slide_editor/record_default.svg',
    group: 'Slide Editor',
    name: 'Record Default',
    size: 'medium'
  },
  'slide-editor-record-hover': {
    file: 'slide_editor/record_hover.svg',
    group: 'Slide Editor',
    name: 'Record Hover',
    size: 'medium'
  },
  'slide-editor-record-selected': {
    file: 'slide_editor/record_selected.svg',
    group: 'Slide Editor',
    name: 'Record Selected',
    size: 'medium'
  },
  'slide-editor-record-disabled': {
    file: 'slide_editor/record_disabled.svg',
    group: 'Slide Editor',
    name: 'Record Disabled',
    size: 'medium'
  },
  'slide-editor-redo-default': {
    file: 'slide_editor/redo_default.svg',
    group: 'Slide Editor',
    name: 'Redo Default',
    size: 'medium'
  },
  'slide-editor-redo-hover': {
    file: 'slide_editor/redo_hover.svg',
    group: 'Slide Editor',
    name: 'Redo Hover',
    size: 'medium'
  },
  'slide-editor-redo-selected': {
    file: 'slide_editor/redo_selected.svg',
    group: 'Slide Editor',
    name: 'Redo Selected',
    size: 'medium'
  },
  'slide-editor-redo-disabled': {
    file: 'slide_editor/redo_disabled.svg',
    group: 'Slide Editor',
    name: 'Redo Disabled',
    size: 'medium'
  },
  'slide-editor-select-default': {
    file: 'slide_editor/select_default.svg',
    group: 'Slide Editor',
    name: 'Select Default',
    size: 'medium'
  },
  'slide-editor-select-hover': {
    file: 'slide_editor/select_hover.svg',
    group: 'Slide Editor',
    name: 'Select Hover',
    size: 'medium'
  },
  'slide-editor-select-selected': {
    file: 'slide_editor/select_selected.svg',
    group: 'Slide Editor',
    name: 'Select Selected',
    size: 'medium'
  },
  'slide-editor-select-disabled': {
    file: 'slide_editor/select_disabled.svg',
    group: 'Slide Editor',
    name: 'Select Disabled',
    size: 'medium'
  },
  'slide-editor-send-to-back-default': {
    file: 'slide_editor/send_to_back_default.svg',
    group: 'Slide Editor',
    name: 'Send to Back Default',
    size: 'medium'
  },
  'slide-editor-send-to-back-hover': {
    file: 'slide_editor/send_to_back_hover.svg',
    group: 'Slide Editor',
    name: 'Send to Back Hover',
    size: 'medium'
  },
  'slide-editor-send-to-back-selected': {
    file: 'slide_editor/send_to_back_selected.svg',
    group: 'Slide Editor',
    name: 'Send to Back Selected',
    size: 'medium'
  },
  'slide-editor-send-to-back-disabled': {
    file: 'slide_editor/send_to_back_disabled.svg',
    group: 'Slide Editor',
    name: 'Send to Back Disabled',
    size: 'medium'
  },
  'slide-editor-shapes-default': {
    file: 'slide_editor/shapes_default.svg',
    group: 'Slide Editor',
    name: 'Shapes Default',
    size: 'medium'
  },
  'slide-editor-shapes-hover': {
    file: 'slide_editor/shapes_hover.svg',
    group: 'Slide Editor',
    name: 'Shapes Hover',
    size: 'medium'
  },
  'slide-editor-shapes-selected': {
    file: 'slide_editor/shapes_selected.svg',
    group: 'Slide Editor',
    name: 'Shapes Selected',
    size: 'medium'
  },
  'slide-editor-shapes-disabled': {
    file: 'slide_editor/shapes_disabled.svg',
    group: 'Slide Editor',
    name: 'Shapes Disabled',
    size: 'medium'
  },
  'slide-editor-text-default': {
    file: 'slide_editor/text_default.svg',
    group: 'Slide Editor',
    name: 'Text Default',
    size: 'medium'
  },
  'slide-editor-text-hover': {
    file: 'slide_editor/text_hover.svg',
    group: 'Slide Editor',
    name: 'Text Hover',
    size: 'medium'
  },
  'slide-editor-text-selected': {
    file: 'slide_editor/text_selected.svg',
    group: 'Slide Editor',
    name: 'Text Selected',
    size: 'medium'
  },
  'slide-editor-text-disabled': {
    file: 'slide_editor/text_disabled.svg',
    group: 'Slide Editor',
    name: 'Text Disabled',
    size: 'medium'
  },
  'slide-editor-undo-default': {
    file: 'slide_editor/undo_default.svg',
    group: 'Slide Editor',
    name: 'Undo Default',
    size: 'medium'
  },
  'slide-editor-undo-hover': {
    file: 'slide_editor/undo_hover.svg',
    group: 'Slide Editor',
    name: 'Undo Hover',
    size: 'medium'
  },
  'slide-editor-undo-selected': {
    file: 'slide_editor/undo_selected.svg',
    group: 'Slide Editor',
    name: 'Undo Selected',
    size: 'medium'
  },
  'slide-editor-undo-disabled': {
    file: 'slide_editor/undo_disabled.svg',
    group: 'Slide Editor',
    name: 'Undo Disabled',
    size: 'medium'
  },
  'slide-editor-upload-audio-file-default': {
    file: 'slide_editor/upload_audio_file_default.svg',
    group: 'Slide Editor',
    name: 'Upload Audio File Default',
    size: 'medium'
  },
  'slide-editor-upload-audio-file-hover': {
    file: 'slide_editor/upload_audio_file_hover.svg',
    group: 'Slide Editor',
    name: 'Upload Audio File Hover',
    size: 'medium'
  },
  'slide-editor-upload-audio-file-selected': {
    file: 'slide_editor/upload_audio_file_selected.svg',
    group: 'Slide Editor',
    name: 'Upload Audio File Selected',
    size: 'medium'
  },
  'slide-editor-upload-audio-file-disabled': {
    file: 'slide_editor/upload_audio_file_disabled.svg',
    group: 'Slide Editor',
    name: 'Upload Audio File Disabled',
    size: 'medium'
  },
  'slide-editor-video-default': {
    file: 'slide_editor/video_default.svg',
    group: 'Slide Editor',
    name: 'Video Default',
    size: 'medium'
  },
  'slide-editor-video-hover': {
    file: 'slide_editor/video_hover.svg',
    group: 'Slide Editor',
    name: 'Video Hover',
    size: 'medium'
  },
  'slide-editor-video-selected': {
    file: 'slide_editor/video_selected.svg',
    group: 'Slide Editor',
    name: 'Video Selected',
    size: 'medium'
  },
  'slide-editor-video-disabled': {
    file: 'slide_editor/video_disabled.svg',
    group: 'Slide Editor',
    name: 'Video Disabled',
    size: 'medium'
  },
  'slide-editor-weight-default': {
    file: 'slide_editor/weight_default.svg',
    group: 'Slide Editor',
    name: 'Weight Default',
    size: 'medium'
  },
  'slide-editor-weight-hover': {
    file: 'slide_editor/weight_hover.svg',
    group: 'Slide Editor',
    name: 'Weight Hover',
    size: 'medium'
  },
  'slide-editor-weight-selected': {
    file: 'slide_editor/weight_selected.svg',
    group: 'Slide Editor',
    name: 'Weight Selected',
    size: 'medium'
  },
  'slide-editor-weight-disabled': {
    file: 'slide_editor/weight_disabled.svg',
    group: 'Slide Editor',
    name: 'Weight Disabled',
    size: 'medium'
  },
  'slide-editor-zoom-default': {
    file: 'slide_editor/zoom_default.svg',
    group: 'Slide Editor',
    name: 'Zoom Default',
    size: 'medium'
  },
  'slide-editor-zoom-hover': {
    file: 'slide_editor/zoom_hover.svg',
    group: 'Slide Editor',
    name: 'Zoom Hover',
    size: 'medium'
  },
  'slide-editor-zoom-selected': {
    file: 'slide_editor/zoom_selected.svg',
    group: 'Slide Editor',
    name: 'Zoom Selected',
    size: 'medium'
  },
  'slide-editor-zoom-disabled': {
    file: 'slide_editor/zoom_disabled.svg',
    group: 'Slide Editor',
    name: 'Zoom Disabled',
    size: 'medium'
  },
  'slide-menu-btn-menu': {
    file: 'slide_menu/btn_menu.svg',
    group: 'Slide Menu',
    name: 'Btn Menu',
    size: 'medium'
  },
  'slide-menu-btn-exit': {
    file: 'slide_menu/btn_exit.svg',
    group: 'Slide Menu',
    name: 'Btn Exit',
    size: 'medium'
  },
  'slide-menu-btn-spam-report': {
    file: 'slide_menu/btn_spam_report.svg',
    group: 'Slide Menu',
    name: 'Btn Spam Report',
    size: 'medium'
  },
  'slide-menu-notes': {
    file: 'slide_menu/notes.svg',
    group: 'Slide Menu',
    name: 'Notes',
    size: 'medium'
  },
  'slide-menu-zoom-logo': {
    file: 'slide_menu/zoom_logo.svg',
    group: 'Slide Menu',
    name: 'Zoom logo',
    size: 'medium'
  },
  'system-ui-arrow-left-dark': {
    file: 'system_ui/arrow_left_dark.svg',
    group: 'System UI',
    name: 'Arrow Left Dark',
    size: 'small'
  },
  'system-ui-arrow-right-white': {
    file: 'system_ui/arrow_right_white.svg',
    group: 'System UI',
    name: 'Arrow Right White',
    size: 'default'
  },
  'system-ui-arrow-right-grey': {
    file: 'system_ui/arrow_right_grey.svg',
    group: 'System UI',
    name: 'Arrow Right Grey',
    size: 'default'
  },
  'system-ui-arrow-left-dark-blue': {
    file: 'system_ui/arrow_left_dark_blue.svg',
    group: 'System UI',
    name: 'Arrow Left Dark Blue',
    size: 'default'
  },
  'system-ui-badge-beta-grey': {
    file: 'system_ui/badge_beta_grey.svg',
    group: 'System UI',
    name: 'Badge Beta Grey',
    size: 'xs-wide'
  },
  'system-ui-badge-beta-orange': {
    file: 'system_ui/badge_beta_orange.svg',
    group: 'System UI',
    name: 'Badge Beta Orange',
    size: 'xs-wide'
  },
  'system-ui-badge-beta-white': {
    file: 'system_ui/badge_beta_white.svg',
    group: 'System UI',
    name: 'Badge Beta White',
    size: 'xs-wide'
  },
  'system-ui-badge-new': {
    file: 'system_ui/badge_new.svg',
    group: 'System UI',
    name: 'Badge New',
    size: 'xs-wide'
  },
  'system-ui-carret-menu-down': {
    file: 'system_ui/carret_menu_down.svg',
    group: 'System UI',
    name: 'Carret Menu Down',
    size: 'xs'
  },
  'system-ui-carret-menu-up': {
    file: 'system_ui/carret_menu_up.svg',
    group: 'System UI',
    name: 'Carret Menu Up',
    size: 'xs'
  },
  'system-ui-carret-down-black': {
    file: 'system_ui/carret_down_black.svg',
    group: 'System UI',
    name: 'Carret Menu Down',
    size: 'xs'
  },
  'system-ui-carret-up-black': {
    file: 'system_ui/carret_up_black.svg',
    group: 'System UI',
    name: 'Carret Menu Up',
    size: 'xs'
  },
  'system-ui-carret-right-black': {
    file: 'system_ui/carret_right_black.svg',
    group: 'System UI',
    name: 'Carret Menu Right',
    size: 'xs'
  },
  'system-ui-check-dark-blue': {
    file: 'system_ui/check_dark_blue.svg',
    group: 'System UI',
    name: 'Check Dark Blue',
    size: 'default'
  },
  'system-ui-check-default': {
    file: 'system_ui/check_default.svg',
    group: 'System UI',
    name: 'Check Default',
    size: 'xs'
  },
  'system-ui-check-hover': {
    file: 'system_ui/check_hover.svg',
    group: 'System UI',
    name: 'Check Hover',
    size: 'xs'
  },
  'system-ui-check-selected': {
    file: 'system_ui/check_selected.svg',
    group: 'System UI',
    name: 'Check Selected',
    size: 'xs'
  },
  'system-ui-check-correct-answer-default': {
    file: 'system_ui/check-correct-answer-green-default.svg',
    group: 'System UI',
    name: 'Check Correct Answer Green',
    size: 'default'
  },
  'system-ui-check-disabled': {
    file: 'system_ui/check_disabled.svg',
    group: 'System UI',
    name: 'Check Disabled',
    size: 'xs'
  },
  'system-ui-check-circle-positive-xs': {
    file: 'system_ui/check_circle_semantic_positive_80.svg',
    group: 'System UI',
    name: 'Check Circle Posite',
    size: 'xs'
  },
  'system-ui-checkmark-default': {
    file: 'system_ui/checkmark_default.svg',
    group: 'System UI',
    name: 'Checkmark Default',
    size: 'default'
  },
  'system-ui-checkmark-medium-neutral-90': {
    file: 'system_ui/checkmark_medium_neutral_90.svg',
    group: 'System UI',
    name: 'Checkmark Medium Neutral 90',
    size: 'medium'
  },
  'system-ui-chevron-left-large': {
    file: 'system_ui/chevron_left.svg',
    group: 'System UI',
    name: 'Chevron Left Large',
    size: 'large'
  },
  'system-ui-chevron-right-large': {
    file: 'system_ui/chevron_right.svg',
    group: 'System UI',
    name: 'Chevron Right Large',
    size: 'large'
  },
  'system-ui-chevron-left-small-default': {
    file: 'system_ui/chevron_left.svg',
    group: 'System UI',
    name: 'Chevron Left Small',
    size: 'small'
  },
  'system-ui-chevron-right-small-default': {
    file: 'system_ui/chevron_right.svg',
    group: 'System UI',
    name: 'Chevron Right Small',
    size: 'small'
  },
  'system-ui-chevron-right-xs-default': {
    file: 'system_ui/chevron_right.svg',
    group: 'System UI',
    name: 'Chevron Right Extra Small',
    size: 'xs'
  },
  'system-ui-chevron-left-small-disabled': {
    file: 'system_ui/chevron_left_disabled.svg',
    group: 'System UI',
    name: 'Chevron Left Small Disabled',
    size: 'small'
  },
  'system-ui-chevron-right-small-disabled': {
    file: 'system_ui/chevron_right_disabled.svg',
    group: 'System UI',
    name: 'Chevron Right Small Disabled',
    size: 'small'
  },
  'system-ui-circle-backslash': {
    file: 'system_ui/circle_backslash.svg',
    group: 'System UI',
    name: 'Circle Backslash',
    size: 'default'
  },
  'system-ui-chevrons-menu-big-blue-down': {
    file: 'system_ui/chevrons_menu_big_blue_down.svg',
    group: 'System UI',
    name: 'Chevrons Menu Big Blue Down',
    size: 'medium'
  },
  'system-ui-chevrons-menu-big-blue-up': {
    file: 'system_ui/chevrons_menu_big_blue_up.svg',
    group: 'System UI',
    name: 'Chevrons Menu Big Blue Up',
    size: 'medium'
  },
  'system-ui-chevrons-menu-big-dark-down': {
    file: 'system_ui/chevrons_menu_big_dark_down.svg',
    group: 'System UI',
    name: 'Chevrons Menu Big Dark Down',
    size: 'medium'
  },
  'system-ui-chevrons-menu-big-dark-up': {
    file: 'system_ui/chevrons_menu_big_dark_up.svg',
    group: 'System UI',
    name: 'Chevrons Menu Big Dark Up',
    size: 'medium'
  },
  'system-ui-chevrons-menu-big-light-down': {
    file: 'system_ui/chevrons_menu_big_light_down.svg',
    group: 'System UI',
    name: 'Chevrons Menu Big Light Down',
    size: 'medium'
  },
  'system-ui-chevrons-menu-big-light-up': {
    file: 'system_ui/chevrons_menu_big_light_up.svg',
    group: 'System UI',
    name: 'Chevrons Menu Big Light Up',
    size: 'medium'
  },
  'system-ui-chevrons-menu-small-blue-down': {
    file: 'system_ui/chevrons_menu_small_blue_down.svg',
    group: 'System UI',
    name: 'Chevrons Menu Small Blue Down',
    size: 'xs'
  },
  'system-ui-chevrons-menu-small-blue-up': {
    file: 'system_ui/chevrons_menu_small_blue_up.svg',
    group: 'System UI',
    name: 'Chevrons Menu Small Blue Up',
    size: 'xs'
  },
  'system-ui-chevrons-menu-small-dark-down': {
    file: 'system_ui/chevrons_menu_small_dark_down.svg',
    group: 'System UI',
    name: 'Chevrons Menu Small Dark Down',
    size: 'xs'
  },
  'system-ui-chevrons-menu-small-dark-up': {
    file: 'system_ui/chevrons_menu_small_dark_up.svg',
    group: 'System UI',
    name: 'Chevrons Menu Small Dark Up',
    size: 'xs'
  },
  'system-ui-chevrons-menu-small-blue-70-down': {
    file: 'system_ui/chevrons_menu_small_blue_70_down.svg',
    group: 'System UI',
    name: 'Chevrons Menu Small Dark Down',
    size: 'xs'
  },
  'system-ui-chevrons-menu-small-blue-70-up': {
    file: 'system_ui/chevrons_menu_small_blue_70_up.svg',
    group: 'System UI',
    name: 'Chevrons Menu Small Dark Up',
    size: 'xs'
  },
  'system-ui-chevrons-menu-small-light-down': {
    file: 'system_ui/chevrons_menu_small_light_down.svg',
    group: 'System UI',
    name: 'Chevrons Menu Small Light Down',
    size: 'xs'
  },
  'system-ui-chevrons-menu-small-light-up': {
    file: 'system_ui/chevrons_menu_small_light_up.svg',
    group: 'System UI',
    name: 'Chevrons Menu Small Light Up',
    size: 'xs'
  },
  'system-ui-close-preview-default': {
    file: 'system_ui/close_preview_default.svg',
    group: 'System UI',
    name: 'Close Preview Default',
    size: 'xs'
  },
  'system-ui-close-preview-hover': {
    file: 'system_ui/close_preview_hover.svg',
    group: 'System UI',
    name: 'Close Preview Hover',
    size: 'xs'
  },
  'system-ui-x-close-blue-sm': {
    file: 'system_ui/close_blue_small.svg',
    group: 'System UI',
    name: 'Close Blue Small',
    size: 'small'
  },
  'system-ui-code-dark-blue': {
    file: 'system_ui/code_dark_blue.svg',
    group: 'System UI',
    name: 'Code Dark Blue',
    size: 'default'
  },
  'system-ui-code-neutral': {
    file: 'system_ui/code_neutral.svg',
    group: 'System UI',
    name: 'Code Neutral',
    size: 'default'
  },
  'system-ui-collapse-expand-all-down-default': {
    file: 'system_ui/collapse_expand_all_down_default.svg',
    group: 'System UI',
    name: 'Collapse / Expand All Down Default',
    size: 'small'
  },
  'system-ui-collapse-expand-all-down-hover': {
    file: 'system_ui/collapse_expand_all_down_hover.svg',
    group: 'System UI',
    name: 'Collapse / Expand All Down Hover',
    size: 'small'
  },
  'system-ui-collapse-expand-all-up-default': {
    file: 'system_ui/collapse_expand_all_up_default.svg',
    group: 'System UI',
    name: 'Collapse / Expand All Up Default',
    size: 'small'
  },
  'system-ui-collapse-expand-all-up-hover': {
    file: 'system_ui/collapse_expand_all_up_hover.svg',
    group: 'System UI',
    name: 'Collapse / Expand All Up Hover',
    size: 'small'
  },
  'system-ui-download-default-blue': {
    file: 'system_ui/download_default_blue.svg',
    group: 'System UI',
    name: 'Download Default Blue',
    size: 'small'
  },
  'system-ui-download-default-dark': {
    file: 'system_ui/download_default_dark.svg',
    group: 'System UI',
    name: 'Download Default Dark',
    size: 'small'
  },
  'system-ui-download-disabled-dark': {
    file: 'system_ui/download_disabled_dark.svg',
    group: 'System UI',
    name: 'Download Disabled Dark',
    size: 'small'
  },
  'system-ui-download-hover-dark': {
    file: 'system_ui/download_hover_dark.svg',
    group: 'System UI',
    name: 'Download Hover Dark',
    size: 'small'
  },
  'system-ui-slim-download-default': {
    file: 'system_ui/slim_download_default.svg',
    group: 'System UI',
    name: 'Slim Download Default',
    size: 'small'
  },
  'system-ui-edit-default': {
    file: 'system_ui/edit_default.svg',
    group: 'System UI',
    name: 'Edit Default',
    size: 'medium'
  },
  'system-ui-edit-hover': {
    file: 'system_ui/edit_hover.svg',
    group: 'System UI',
    name: 'Edit Hover',
    size: 'medium'
  },
  'system-ui-edit-white': {
    file: 'system_ui/edit_white.svg',
    group: 'System UI',
    name: 'Edit White',
    size: 'medium'
  },
  'system-ui-envelope-dark-blue': {
    file: 'system_ui/envelope_dark_blue.svg',
    group: 'System UI',
    name: 'Envelope Dark Blue',
    size: 'default'
  },
  'system-ui-envelope-neutral': {
    file: 'system_ui/envelope_neutral.svg',
    group: 'System UI',
    name: 'Envelope Neutral',
    size: 'default'
  },
  'system-ui-error': {
    file: 'system_ui/error.svg',
    group: 'System UI',
    name: 'Error',
    size: 'xs'
  },
  'system-ui-error-semantic-negative-base-xs': {
    file: 'system_ui/error_semantic_negative_base.svg',
    group: 'System UI',
    name: 'Error',
    size: 'xs'
  },
  'system-ui-error-semantic-negative-80-xs': {
    file: 'system_ui/error_semantic_negative_80.svg',
    group: 'System UI',
    name: 'Error',
    size: 'xs'
  },
  'system-ui-error-semantic-notice-80-xs': {
    file: 'system_ui/error_semantic_notice_80.svg',
    group: 'System UI',
    name: 'Error',
    size: 'xs'
  },
  'system-ui-warning-semantic-notice-80-xs': {
    file: 'system_ui/warning_semantic_notice_80.svg',
    group: 'System UI',
    name: 'Warning',
    size: 'xs'
  },
  'system-ui-warning-semantic-notice-90-xs': {
    file: 'system_ui/warning_semantic_notice_90.svg',
    group: 'System UI',
    name: 'Warning',
    size: 'xs'
  },
  'system-ui-warning-semantic-notice-red-xs': {
    file: 'system_ui/warning_semantic_notice_red.svg',
    group: 'System UI',
    name: 'Warning Red',
    size: 'xs'
  },
  'system-ui-stop': {
    file: 'system_ui/x_close_stop.svg',
    group: 'System UI',
    name: 'Stop',
    size: 'default'
  },
  'system-ui-expand-default': {
    file: 'system_ui/expand_default.svg',
    group: 'System UI',
    name: 'Expand Default',
    size: 'small'
  },
  'system-ui-expand-hover': {
    file: 'system_ui/expand_hover.svg',
    group: 'System UI',
    name: 'Expand Hover',
    size: 'small'
  },
  'system-ui-filter': {
    file: 'system_ui/filter.svg',
    group: 'System UI',
    name: 'Filter',
    size: 'small'
  },
  'system-ui-full-screen-icon-label-dark-default': {
    file: 'system_ui/full_screen_icon_label_dark_default.svg',
    group: 'System UI',
    name: 'Full Screen Icon Label Dark Default',
    size: 'medium-wide'
  },
  'system-ui-full-screen-icon-label-dark-disabled': {
    file: 'system_ui/full_screen_icon_label_dark_disabled.svg',
    group: 'System UI',
    name: 'Full Screen Icon Label Dark Disabled',
    size: 'medium-wide'
  },
  'system-ui-full-screen-icon-label-dark-hover': {
    file: 'system_ui/full_screen_icon_label_dark_hover.svg',
    group: 'System UI',
    name: 'Full Screen Icon Label Dark Hover',
    size: 'medium-wide'
  },
  'system-ui-full-screen-icon-label-light-default': {
    file: 'system_ui/full_screen_icon_label_light_default.svg',
    group: 'System UI',
    name: 'Full Screen Icon Label Light Default',
    size: 'medium-wide'
  },
  'system-ui-full-screen-icon-label-light-disabled': {
    file: 'system_ui/full_screen_icon_label_light_disabled.svg',
    group: 'System UI',
    name: 'Full Screen Icon Label Light Disabled',
    size: 'medium-wide'
  },
  'system-ui-full-screen-icon-label-light-hover': {
    file: 'system_ui/full_screen_icon_label_light_hover.svg',
    group: 'System UI',
    name: 'Full Screen Icon Label Light Hover',
    size: 'medium-wide'
  },
  'system-ui-full-screen-icon-light-default': {
    file: 'system_ui/full_screen_icon_light_default.svg',
    group: 'System UI',
    name: 'Full Screen Icon Light Default',
    size: 'medium'
  },
  'system-ui-full-screen-icon-light-disabled': {
    file: 'system_ui/full_screen_icon_light_disabled.svg',
    group: 'System UI',
    name: 'Full Screen Icon Light Disabled',
    size: 'medium'
  },
  'system-ui-full-screen-icon-light-hover': {
    file: 'system_ui/full_screen_icon_light_hover.svg',
    group: 'System UI',
    name: 'Full Screen Icon Light Hover',
    size: 'medium'
  },
  'system-ui-filter-default': {
    file: 'system_ui/filter_icon_default.svg',
    group: 'System UI',
    name: 'Filter Icon Default',
    size: 'small'
  },
  'system-ui-filter-hover': {
    file: 'system_ui/filter_icon_hover.svg',
    group: 'System UI',
    name: 'Filter Icon Hover',
    size: 'small'
  },
  'system-ui-filter-selected': {
    file: 'system_ui/filter_icon_selected.svg',
    group: 'System UI',
    name: 'Filter Icon Selected',
    size: 'small'
  },
  'system-ui-intercom': {
    file: 'system_ui/intercom.svg',
    group: 'System UI',
    name: 'Intercom',
    size: 'xl'
  },
  'system-ui-join-lesson-button-default': {
    file: 'system_ui/join_lesson_button_default.svg',
    group: 'System UI',
    name: 'Join Lesson Button Default',
    size: 'small'
  },
  'system-ui-join-lesson-button-hover': {
    file: 'system_ui/join_lesson_button_hover.svg',
    group: 'System UI',
    name: 'Join Lesson Button Hover',
    size: 'small'
  },
  'system-ui-left-arrow': {
    file: 'system_ui/left_arrow.svg',
    group: 'System UI',
    name: 'Left Arrow',
    size: 'default'
  },
  'system-ui-notifications-grey': {
    file: 'system_ui/notifications_grey.svg',
    group: 'System UI',
    name: 'Notifications Grey',
    size: 'xs'
  },
  'system-ui-notifications-white': {
    file: 'system_ui/notifications_white.svg',
    group: 'System UI',
    name: 'Notifications White',
    size: 'xs'
  },
  'system-ui-open-close-drawer-show': {
    file: 'system_ui/open_close_drawer_show.svg',
    group: 'System UI',
    name: 'Open Close Drawer Show',
    size: 'xs'
  },
  'system-ui-open-close-drawer-hide': {
    file: 'system_ui/open_close_drawer_hide.svg',
    group: 'System UI',
    name: 'Open Close Drawer Hide',
    size: 'xs'
  },
  'system-ui-open-close-drawer-blue': {
    file: 'system_ui/open_close_drawer_blue.svg',
    group: 'System UI',
    name: 'Open Close Drawer Blue',
    size: 'xs'
  },
  'system-ui-plus-light-shadow': {
    file: 'system_ui/plus_light_shadow.svg',
    group: 'System UI',
    name: 'Plus Light Shadow',
    size: 'xs'
  },
  'system-ui-right-arrow': {
    file: 'system_ui/right_arrow.svg',
    group: 'System UI',
    name: 'Right Arrow',
    size: 'xs'
  },
  'system-ui-right-arrow-medium-default': {
    file: 'system_ui/right_arrow.svg',
    group: 'System UI',
    name: 'Right Arrow Medium',
    size: 'small'
  },
  'system-ui-right-arrow-medium-hover': {
    file: 'system_ui/right_arrow_medium_hover.svg',
    group: 'System UI',
    name: 'Right Arrow Medium Hover',
    size: 'small'
  },
  'system-ui-search-lens-strong': {
    file: 'system_ui/search_lens_strong.svg',
    group: 'System UI',
    name: 'Search Lens Strong',
    size: 'small'
  },
  'system-ui-search-lens-strong-default': {
    file: 'system_ui/search_lens_strong.svg',
    group: 'System UI',
    name: 'Search Lens Strong',
    size: 'default'
  },
  'system-ui-search-lens-thin': {
    file: 'system_ui/search_lens_thin.svg',
    group: 'System UI',
    name: 'Search Lens Thin',
    size: 'small'
  },
  'system-ui-search-x-delete': {
    file: 'system_ui/search_x_delete.svg',
    group: 'System UI',
    name: 'Search X Delete',
    size: 'small'
  },
  'system-ui-send-blue-default': {
    file: 'system_ui/send_blue_default.svg',
    group: 'System UI',
    name: 'Send Blue Default',
    size: 'small'
  },
  'system-ui-send-dark-default': {
    file: 'system_ui/send_dark_default.svg',
    group: 'System UI',
    name: 'Send Dark Default',
    size: 'small'
  },
  'system-ui-send-dark-hover': {
    file: 'system_ui/send_dark_hover.svg',
    group: 'System UI',
    name: 'Send Dark Hover',
    size: 'small'
  },
  'system-ui-send-dark-disabled': {
    file: 'system_ui/send_dark_disabled.svg',
    group: 'System UI',
    name: 'Send Dark Disabled',
    size: 'small'
  },
  'system-ui-send-feedback': {
    file: 'system_ui/send_feedback.svg',
    group: 'System UI',
    name: 'Send Feedback',
    size: 'large'
  },
  'system-ui-send-light-default': {
    file: 'system_ui/send_light_default.svg',
    group: 'System UI',
    name: 'Send Light Default',
    size: 'small'
  },
  'system-ui-send-light-hover': {
    file: 'system_ui/send_light_hover.svg',
    group: 'System UI',
    name: 'Send Light Hover',
    size: 'small'
  },
  'system-ui-share-permissions': {
    file: 'system_ui/share_permissions.svg',
    group: 'System UI',
    name: 'Share Permissions',
    size: 'small'
  },
  'system-ui-storage-unlimited': {
    file: 'system_ui/storage_unlimited.svg',
    group: 'System UI',
    name: 'Storage Unlimited',
    size: 'default'
  },
  'system-ui-storage-warning': {
    file: 'system_ui/storage_warning.svg',
    group: 'System UI',
    name: 'Storage Warning',
    size: 'default'
  },
  'system-ui-success': {
    file: 'system_ui/success.svg',
    group: 'System UI',
    name: 'Success',
    size: 'xs'
  },
  'system-ui-tooltips-big-grey-question-mark': {
    file: 'system_ui/tooltips_big_grey_question_mark.svg',
    group: 'System UI',
    name: 'Tooltips Big Grey Question Mark',
    size: 'medium'
  },
  'system-ui-tooltips-big-white-question-mark': {
    file: 'system_ui/tooltips_big_white_question_mark.svg',
    group: 'System UI',
    name: 'Tooltips Big White Question Mark',
    size: 'medium'
  },
  'system-ui-tooltips-small-dark-hint': {
    file: 'system_ui/tooltips_small_dark_hint.svg',
    group: 'System UI',
    name: 'Tooltips Small Dark Hint',
    size: 'xs'
  },
  'system-ui-tooltips-small-grey-question-mark': {
    file: 'system_ui/tooltips_small_grey_question_mark.svg',
    group: 'System UI',
    name: 'Tooltips Small Grey Question Mark',
    size: 'small'
  },
  'system-ui-upload-arrow': {
    file: 'system_ui/upload_arrow.svg',
    group: 'System UI',
    name: 'Upload Arrow',
    size: 'small'
  },
  'system-ui-upload-default-blue': {
    file: 'system_ui/upload_default_blue.svg',
    group: 'System UI',
    name: 'Upload Default Blue',
    size: 'medium'
  },
  'system-ui-upload-default-blue-large': {
    file: 'system_ui/upload_default_blue.svg',
    group: 'System UI',
    name: 'Upload Default Blue',
    size: 'large'
  },
  'system-ui-upload-default-dark': {
    file: 'system_ui/upload_default_dark.svg',
    group: 'System UI',
    name: 'Upload Default Dark',
    size: 'medium'
  },
  'system-ui-upload-disabled-dark': {
    file: 'system_ui/upload_disabled_dark.svg',
    group: 'System UI',
    name: 'Upload Disabled Dark',
    size: 'medium'
  },
  'system-ui-warning': {
    file: 'system_ui/warning.svg',
    group: 'System UI',
    name: 'Warning',
    size: 'xs'
  },
  'system-ui-x-close-dark': {
    file: 'system_ui/x_close_dark.svg',
    group: 'System UI',
    name: 'X Close Dark',
    size: 'medium'
  },
  'system-ui-x-close-dark-xs': {
    file: 'system_ui/x_close_dark.svg',
    group: 'System UI',
    name: 'X Close Dark',
    size: 'xs'
  },
  'system-ui-x-close-dark-xxs': {
    file: 'system_ui/x_close_dark_xxs.svg',
    group: 'System UI',
    name: 'X Close Dark XXS',
    size: 'default'
  },
  'system-ui-x-close-darker-xxs': {
    file: 'system_ui/x_close_darker_xxs.svg',
    group: 'System UI',
    name: 'X Close Darker XXS',
    size: 'default'
  },
  'system-ui-x-close-darker': {
    file: 'system_ui/x_close_darker.svg',
    group: 'System UI',
    name: 'X Close Darker',
    size: 'small'
  },
  'system-ui-x-close-light': {
    file: 'system_ui/x_close_light.svg',
    group: 'System UI',
    name: 'X Close Light',
    size: 'medium'
  },
  'system-ui-x-close-light-default': {
    file: 'system_ui/x_close_light_default.svg',
    group: 'System UI',
    name: 'X Close Light default',
    size: 'default'
  },
  'system-ui-x-close-neutral-90-xs': {
    file: 'system_ui/x_close_neutral_90.svg',
    group: 'System UI',
    name: 'X Close Neutral 90',
    size: 'xs'
  },
  'system-ui-table-order-desc': {
    file: 'system_ui/table_order_desc.svg',
    group: 'System UI',
    name: 'Table Ordering (desc)',
    size: 'xs'
  },
  'system-ui-table-order-asc': {
    file: 'system_ui/table_order_asc.svg',
    group: 'System UI',
    name: 'Table Ordering (asc)',
    size: 'xs'
  },
  'system-ui-keyboard': {
    file: 'system_ui/keyboard.svg',
    group: 'My Lesson Gallery',
    name: 'Keyboard',
    size: 'small'
  },
  'system-ui-lamp-default': {
    file: 'system_ui/lamp-default.svg',
    group: 'System UI',
    name: 'Lamp Default',
    size: 'default'
  },
  'system-ui-counter-1': {
    file: 'system_ui/counter_1.svg',
    group: 'System UI',
    name: 'Counter 1',
    size: 'default'
  },
  'system-ui-counter-2': {
    file: 'system_ui/counter_2.svg',
    group: 'System UI',
    name: 'Counter 2',
    size: 'default'
  },
  'reports-checkbox-checked-gray-xs': {
    file: 'reports/checkbox_checked.svg',
    group: 'Reports',
    name: 'Checked checkbox xs',
    size: 'xs'
  },
  'reports-checkbox-empty-xs': {
    file: 'reports/checkbox_empty.svg',
    group: 'Reports',
    name: 'Empty checkbox xs',
    size: 'xs'
  },
  'reports-checkbox-checked-gray-small': {
    file: 'reports/checkbox_checked.svg',
    group: 'Reports',
    name: 'Checked checkbox small',
    size: 'small'
  },
  'reports-checkbox-empty-small': {
    file: 'reports/checkbox_empty.svg',
    group: 'Reports',
    name: 'Empty checkbox small',
    size: 'small'
  },
  'reports-radio-checked-gray-xs': {
    file: 'reports/radio_checked.svg',
    group: 'Reports',
    name: 'Checked radio button xs',
    size: 'xs'
  },
  'reports-radio-empty-xs': {
    file: 'reports/radio_empty.svg',
    group: 'Reports',
    name: 'Empty radio button xs',
    size: 'xs'
  },
  'reports-radio-checked-gray-small': {
    file: 'reports/radio_checked.svg',
    group: 'Reports',
    name: 'Checked radio button small',
    size: 'small'
  },
  'reports-radio-empty-small': {
    file: 'reports/radio_empty.svg',
    group: 'Reports',
    name: 'Empty radio button small',
    size: 'small'
  },
  'reports-dash-default': {
    file: 'reports/check_indeterminate_small.svg',
    group: 'Reports',
    name: 'Dash default',
    size: 'default'
  },
  'reports-dash-large': {
    file: 'reports/check_indeterminate_small.svg',
    group: 'Reports',
    name: 'Dash medium',
    size: 'large'
  },
  'reports-dash-medium': {
    file: 'reports/check_indeterminate_small.svg',
    group: 'Reports',
    name: 'Dash medium',
    size: 'medium'
  },
  'reports-dash-small': {
    file: 'reports/check_indeterminate_small.svg',
    group: 'Reports',
    name: 'Dash small',
    size: 'small'
  },
  'reports-dash-xs': {
    file: 'reports/check_indeterminate_small.svg',
    group: 'Reports',
    name: 'Dash xs',
    size: 'xs'
  },
  'reports-back-chevron-default': {
    file: 'reports/chevron_left.svg',
    group: 'Reports',
    name: 'Left chevron default',
    size: 'default'
  },
  'reports-back-chevron-large': {
    file: 'reports/chevron_left.svg',
    group: 'Reports',
    name: 'Left chevron large',
    size: 'large'
  },
  'reports-back-chevron-medium': {
    file: 'reports/chevron_left.svg',
    group: 'Reports',
    name: 'Left chevron medium',
    size: 'medium'
  },
  'reports-back-chevron-small': {
    file: 'reports/chevron_left.svg',
    group: 'Reports',
    name: 'Left chevron small',
    size: 'small'
  },
  'reports-back-chevron-xs': {
    file: 'reports/chevron_left.svg',
    group: 'Reports',
    name: 'Left chevron small',
    size: 'xs'
  },
  'reports-info-small': {
    file: 'reports/info.svg',
    group: 'Reports',
    name: 'info',
    size: 'small'
  },
  'reports-info-xs': {
    file: 'reports/info.svg',
    group: 'Reports',
    name: 'info',
    size: 'xs'
  },
  'reports-trending-up': {
    file: 'reports/trending_up.svg',
    group: 'Reports',
    name: 'trending-up',
    size: 'small'
  },
  'reports-trending-up-xs': {
    file: 'reports/trending_up.svg',
    group: 'Reports',
    name: 'trending-up',
    size: 'xs'
  },
  'reports-trending-down': {
    file: 'reports/trending_down.svg',
    group: 'Reports',
    name: 'trending-down',
    size: 'small'
  },
  'reports-trending-down-xs': {
    file: 'reports/trending_down.svg',
    group: 'Reports',
    name: 'trending-down',
    size: 'xs'
  },
  'reports-arrow-forward': {
    file: 'reports/arrow_forward.svg',
    group: 'Reports',
    name: 'arrow-forward',
    size: 'small'
  },
  'reports-arrow-drop-up': {
    file: 'reports/arrow_drop_up.svg',
    group: 'Reports',
    name: 'arrow-drop-up',
    size: 'small'
  },
  'reports-arrow-drop-up-asc': {
    file: 'reports/arrow_drop_up_asc.svg',
    group: 'Reports',
    name: 'arrow-drop-up-asc',
    size: 'small'
  },
  'reports-arrow-drop-up-desc': {
    file: 'reports/arrow_drop_up_desc.svg',
    group: 'Reports',
    name: 'arrow-drop-up-desc',
    size: 'small'
  },
  'reports-file-download': {
    file: 'reports/file_download.svg',
    group: 'Reports',
    name: 'file-download',
    size: 'small'
  },
  'reports-file-download-gray-small': {
    file: 'reports/file_download_gray.svg',
    group: 'Reports',
    name: 'file-download-gray-small',
    size: 'small'
  },
  'reports-time-to-climb': {
    file: 'reports/time_to_climb_activity.svg',
    group: 'Reports',
    name: 'time-to-climb',
    size: 'small'
  },
  'reports-draw-it': {
    file: 'reports/draw_it_activity.svg',
    group: 'Reports',
    name: 'draw-it',
    size: 'small'
  },
  'reports-fill-in-the-blank': {
    file: 'reports/fill_in_the_blank_activity.svg',
    group: 'Reports',
    name: 'fill-in-the-blank',
    size: 'small'
  },
  'reports-collaborate-board': {
    file: 'reports/collaborate_board_activity.svg',
    group: 'Reports',
    name: 'collaborate-board',
    size: 'small'
  },
  'reports-quiz': {
    file: 'reports/quiz_activity.svg',
    group: 'Reports',
    name: 'quiz',
    size: 'small'
  },
  'reports-poll': {
    file: 'reports/poll_activity.svg',
    group: 'Reports',
    name: 'poll',
    size: 'small'
  },
  'reports-drag-and-drop': {
    file: 'reports/drag_and_drop_activity.svg',
    group: 'Reports',
    name: 'drag-and-drop',
    size: 'small'
  },
  'reports-open-ended-question': {
    file: 'reports/open_ended_question_activity.svg',
    group: 'Reports',
    name: 'open-ended-question',
    size: 'small'
  },
  'reports-matchin-pairs': {
    file: 'reports/matchin_pairs_activity.svg',
    group: 'Reports',
    name: 'matchin-pairs',
    size: 'small'
  },
  'reports-fraction-tiles': {
    file: 'reports/fraction_tiles_activity.svg',
    group: 'Reports',
    name: 'fraction-tiles',
    size: 'small'
  },
  'reports-color-tiles': {
    file: 'reports/color_tiles_activity.svg',
    group: 'Reports',
    name: 'color-tiles',
    size: 'small'
  },
  'reports-base-10-blocks': {
    file: 'reports/base_10_blocks_activity.svg',
    group: 'Reports',
    name: 'base-10-blocks',
    size: 'small'
  },
  'reports-algebra-tiles': {
    file: 'reports/algebra_tiles_activity.svg',
    group: 'Reports',
    name: 'algebra-tiles',
    size: 'small'
  },
  'reports-quizzes-&-games': {
    file: 'reports/quizzes_&_games_activity.svg',
    group: 'Reports',
    name: 'quizzes-&-games',
    size: 'small'
  },
  'reports-discussions': {
    file: 'reports/discussions_activity.svg',
    group: 'Reports',
    name: 'discussions',
    size: 'small'
  },
  'reports-math-manipulatives': {
    file: 'reports/math_manipulatives_activity.svg',
    group: 'Reports',
    name: 'math-manipulatives',
    size: 'small'
  },
  'reports-quizzes-&-games-xs': {
    file: 'reports/quizzes_&_games_activity.svg',
    group: 'Reports',
    name: 'quizzes-&-games-xs',
    size: 'xs'
  },
  'reports-discussions-xs': {
    file: 'reports/discussions_activity.svg',
    group: 'Reports',
    name: 'discussions-xs',
    size: 'xs'
  },
  'reports-math-manipulatives-xs': {
    file: 'reports/math_manipulatives_activity.svg',
    group: 'Reports',
    name: 'math-manipulatives-xs',
    size: 'xs'
  },
  'reports-premium-badge': {
    file: 'reports/premium_badge.svg',
    group: 'Reports',
    name: 'premium-badge',
    size: 'xs'
  },
  'reports-chevron-backward-small-default': {
    file: 'reports/chevron_left_blue.svg',
    group: 'Reports',
    name: 'chevron-backward-small-default',
    size: 'small'
  },
  'reports-chevron-backward-small-disabled': {
    file: 'reports/chevron_left_gray.svg',
    group: 'Reports',
    name: 'chevron-backward-small-disabled',
    size: 'small'
  },
  'reports-chevron-forward-small-default': {
    file: 'reports/chevron_rigth_blue.svg',
    group: 'Reports',
    name: 'chevron-forward-small-default',
    size: 'small'
  },
  'reports-chevron-forward-small-disabled': {
    file: 'reports/chevron_rigth_gray.svg',
    group: 'Reports',
    name: 'chevron-forward-small-disabled',
    size: 'small'
  },
  'reports-memory-game': {
    file: 'reports/memory_game_activity.svg',
    group: 'Reports',
    name: 'memory-game',
    size: 'small'
  },
  'reports-flipgrid-small': {
    file: 'reports/flip_grid_activity.svg',
    group: 'Reports',
    name: 'flipgrid-sm',
    size: 'small'
  },
  'reports-video-small': {
    file: 'reports/video_activity.svg',
    group: 'Reports',
    name: 'video-sm',
    size: 'small'
  },
  'reports-thumbs-up-down-default': {
    file: 'reports/thumbs_up_down_default.svg',
    group: 'Reports',
    name: 'thumbs-up-down-default',
    size: 'default'
  },
  'reports-thumbs-up-down-dark': {
    file: 'reports/thumbs_up_down_dark.svg',
    group: 'Reports',
    name: 'thumbs-up-down-dark',
    size: 'default'
  },
  'reactions-raised-hand': {
    file: 'reactions/raised_hand.svg',
    group: 'Reactions',
    name: 'reactions-reaised-hand-default',
    size: 'default'
  },
  'reactions-slow-down': {
    file: 'reactions/fast_reverse.svg',
    group: 'Reactions',
    name: 'reactions-slow-down-default',
    size: 'default'
  },
  'reactions-repeat': {
    file: 'reactions/repeat.svg',
    group: 'Reactions',
    name: 'reactions-repeat-default',
    size: 'default'
  },
  'student-reactions-icon': {
    file: 'student_reactions/student_reactions_icon.svg',
    group: 'Student Reactions',
    name: 'Student Reactions Icon',
    size: 'default'
  },
  'student-reactions-disabled-icon': {
    file: 'student_reactions/student_reactions_disabled_icon.svg',
    group: 'Student Reactions',
    name: 'Student Reactions Disabled Icon',
    size: 'default'
  },
  'student-reactions-thumbs-up-sm': {
    file: 'student_reactions/thumbs_up.svg',
    group: 'Student Reactions',
    name: 'Thumbs Up Small',
    size: 'small'
  },
  'student-reactions-clapping-hands-sm': {
    file: 'student_reactions/clapping_hands.svg',
    group: 'Student Reactions',
    name: 'Clapping Hands Small',
    size: 'small'
  },
  'student-reactions-party-popper-sm': {
    file: 'student_reactions/party_popper.svg',
    group: 'Student Reactions',
    name: 'Party Popper Small',
    size: 'small'
  },
  'student-reactions-face-with-open-mouth-sm': {
    file: 'student_reactions/face_with_open_mouth.svg',
    group: 'Student Reactions',
    name: 'Face With Open Mouth Small',
    size: 'small'
  },
  'student-reactions-grinning-face-with-smiling-eyes-sm': {
    file: 'student_reactions/grinning_face_with_smiling_eyes.svg',
    group: 'Student Reactions',
    name: 'Grinning Face With Smiling Eyes Small',
    size: 'small'
  },
  'student-reactions-nerd-face-sm': {
    file: 'student_reactions/nerd_face.svg',
    group: 'Student Reactions',
    name: 'Nerd Face Small',
    size: 'small'
  },
  'student-reactions-thinking-face-sm': {
    file: 'student_reactions/thinking_face.svg',
    group: 'Student Reactions',
    name: 'Thinking Face Small',
    size: 'small'
  },
  'student-reactions-face-with-spiral-eyes-sm': {
    file: 'student_reactions/face_with_spiral_eyes.svg',
    group: 'Student Reactions',
    name: 'Face With Spiral Eyes Small',
    size: 'small'
  },
  'student-reactions-thumbs-up-default': {
    file: 'student_reactions/thumbs_up_big.svg',
    group: 'Student Reactions',
    name: 'Thumbs Up Big',
    size: 'default'
  },
  'student-reactions-clapping-hands-default': {
    file: 'student_reactions/clapping_hands_big.svg',
    group: 'Student Reactions',
    name: 'Clapping Hands Big',
    size: 'default'
  },
  'student-reactions-party-popper-default': {
    file: 'student_reactions/party_popper_big.svg',
    group: 'Student Reactions',
    name: 'Party Popper Big',
    size: 'default'
  },
  'student-reactions-face-with-open-mouth-default': {
    file: 'student_reactions/face_with_open_mouth_big.svg',
    group: 'Student Reactions',
    name: 'Face With Open Mouth Big',
    size: 'default'
  },
  'student-reactions-grinning-face-with-smiling-eyes-default': {
    file: 'student_reactions/grinning_face_with_smiling_eyes_big.svg',
    group: 'Student Reactions',
    name: 'Grinning Face With Smiling Eyes Big',
    size: 'default'
  },
  'student-reactions-nerd-face-default': {
    file: 'student_reactions/nerd_face_big.svg',
    group: 'Student Reactions',
    name: 'Nerd Face Big',
    size: 'default'
  },
  'student-reactions-thinking-face-default': {
    file: 'student_reactions/thinking_face_big.svg',
    group: 'Student Reactions',
    name: 'Thinking Face Big',
    size: 'default'
  },
  'student-reactions-face-with-spiral-eyes-default': {
    file: 'student_reactions/face_with_spiral_eyes_big.svg',
    group: 'Student Reactions',
    name: 'Face With Spiral Eyes Big',
    size: 'default'
  },
  'ai-builder-activity-banks-default': {
    file: 'ai_builder/activity-banks-default.svg',
    group: 'AI Builder',
    name: 'Activity Banks Default',
    size: 'default'
  },
  'ai-builder-stars-default': {
    file: 'ai_builder/ai-stars-default.svg',
    group: 'AI Builder',
    name: 'Stars Default',
    size: 'default'
  },
  'ai-builder-stars-default-xs': {
    file: 'ai_builder/ai-stars-default.svg',
    group: 'AI Builder',
    name: 'Stars Default XS',
    size: 'xs'
  },
  'ai-builder-stars-white': {
    file: 'ai_builder/ai-stars-white.svg',
    group: 'AI Builder',
    name: 'Stars White',
    size: 'default'
  },
  'ai-builder-slide-themes-default': {
    file: 'ai_builder/slide-themes-default.svg',
    group: 'AI Builder',
    name: 'Slide Themes Default',
    size: 'default'
  },
  'ai-builder-quiz-activities-default': {
    file: 'ai_builder/quiz-activities-default.svg',
    group: 'AI Builder',
    name: 'Quiz Activities',
    size: 'default'
  }
};
var iconMapping$1 = iconMapping;

export { iconMapping$1 as default };
//# sourceMappingURL=iconMapping.js.map
